import { JSX } from 'react';
import addLegIcon from '../../assets/icons/add-leg.svg';
import addShipmentIcon from '../../assets/icons/box-add.svg';

export const Icons: { [key: string]: (fill?: boolean) => JSX.Element } = {
  search: () => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
    >
      <path
        d='M10.1253 18.2497C11.6318 18.2494 13.102 17.8279 14.3733 17.0414C14.803 16.7755 15.3676 16.8039 15.7249 17.1612L18.8568 20.293C19.2473 20.6834 19.8804 20.6835 20.2709 20.293L20.2928 20.2711C20.6834 19.8805 20.6834 19.2473 20.2928 18.8568L17.1612 15.7253C16.8038 15.368 16.7754 14.8033 17.0415 14.3735C17.8285 13.1021 18.2502 11.6317 18.2506 10.1249C18.2506 5.64502 14.6054 2 10.1253 2C5.64521 2 2 5.64502 2 10.1249C2 14.6047 5.64521 18.2497 10.1253 18.2497ZM10.1253 4.03122C13.4861 4.03122 16.2193 6.76422 16.2193 10.1249C16.2193 13.4855 13.4861 16.2185 10.1253 16.2185C6.76447 16.2185 4.03133 13.4855 4.03133 10.1249C4.03133 6.76422 6.76447 4.03122 10.1253 4.03122Z'
        fill='#292D32'
      />
    </svg>
  ),
  open: () => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
    >
      <path
        d='M10 20C15.51 20 20 15.51 20 10C20 4.49 15.51 3.92528e-07 10 8.74228e-07C4.49 1.35593e-06 -1.35593e-06 4.49 -8.74228e-07 10C-3.92528e-07 15.51 4.49 20 10 20ZM8.21 7C7.92 6.71 7.92 6.23 8.21 5.94C8.36 5.79 8.55 5.72 8.74 5.72C8.93 5.72 9.12 5.79 9.27 5.94L12.8 9.47C13.09 9.76 13.09 10.24 12.8 10.53L9.27 14.06C8.98 14.35 8.5 14.35 8.21 14.06C7.92 13.77 7.92 13.29 8.21 13L11.21 10L8.21 7Z'
        fill='black'
      />
    </svg>
  ),
  close: () => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
    >
      <path
        d='M10 -1.74846e-06C4.49 -7.85056e-07 7.85056e-07 4.49 1.74846e-06 10C2.71185e-06 15.51 4.49 20 10 20C15.51 20 20 15.51 20 10C20 4.49 15.51 -2.71185e-06 10 -1.74846e-06ZM11.79 13C12.08 13.29 12.08 13.77 11.79 14.06C11.64 14.21 11.45 14.28 11.26 14.28C11.07 14.28 10.88 14.21 10.73 14.06L7.2 10.53C6.91 10.24 6.91 9.76 7.2 9.47L10.73 5.94C11.02 5.65 11.5 5.65 11.79 5.94C12.08 6.23 12.08 6.71 11.79 7L8.79 10L11.79 13Z'
        fill='black'
      />
    </svg>
  ),
  mybbe: (fill?: boolean) => (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M22 21.25H21V15C21 10.03 16.97 6 12 6C7.03 6 3 10.03 3 15V21.25H2C1.59 21.25 1.25 21.59 1.25 22C1.25 22.41 1.59 22.75 2 22.75H22C22.41 22.75 22.75 22.41 22.75 22C22.75 21.59 22.41 21.25 22 21.25Z'
        fill={fill ? '#251163' : '#292D32'}
      />
      <path
        d='M12 3.75C11.59 3.75 11.25 3.41 11.25 3V2C11.25 1.59 11.59 1.25 12 1.25C12.41 1.25 12.75 1.59 12.75 2V3C12.75 3.41 12.41 3.75 12 3.75Z'
        fill={fill ? '#251163' : '#292D32'}
      />
      <path
        d='M5 5.75C4.81 5.75 4.62 5.68 4.47 5.53L3.47 4.53C3.18 4.24 3.18 3.76 3.47 3.47C3.76 3.18 4.24 3.18 4.53 3.47L5.53 4.47C5.82 4.76 5.82 5.24 5.53 5.53C5.38 5.68 5.19 5.75 5 5.75Z'
        fill={fill ? '#251163' : '#292D32'}
      />
      <path
        d='M19 5.75C18.81 5.75 18.62 5.68 18.47 5.53C18.18 5.24 18.18 4.76 18.47 4.47L19.47 3.47C19.76 3.18 20.24 3.18 20.53 3.47C20.82 3.76 20.82 4.24 20.53 4.53L19.53 5.53C19.38 5.68 19.19 5.75 19 5.75Z'
        fill={fill ? '#251163' : '#292D32'}
      />
    </svg>
  ),
  quote: (fill) => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
    >
      <path
        d='M7 2H6C3 2 2 3.79 2 6V7V21C2 21.83 2.94 22.3 3.6 21.8L5.31 20.52C5.71 20.22 6.27 20.26 6.63 20.62L8.29 22.29C8.68 22.68 9.32 22.68 9.71 22.29L11.39 20.61C11.74 20.26 12.3 20.22 12.69 20.52L14.4 21.8C15.06 22.29 16 21.82 16 21V4C16 2.9 16.9 2 18 2H7ZM5.97 14.01C5.42 14.01 4.97 13.56 4.97 13.01C4.97 12.46 5.42 12.01 5.97 12.01C6.52 12.01 6.97 12.46 6.97 13.01C6.97 13.56 6.52 14.01 5.97 14.01ZM5.97 10.01C5.42 10.01 4.97 9.56 4.97 9.01C4.97 8.46 5.42 8.01 5.97 8.01C6.52 8.01 6.97 8.46 6.97 9.01C6.97 9.56 6.52 10.01 5.97 10.01ZM12 13.76H9C8.59 13.76 8.25 13.42 8.25 13.01C8.25 12.6 8.59 12.26 9 12.26H12C12.41 12.26 12.75 12.6 12.75 13.01C12.75 13.42 12.41 13.76 12 13.76ZM12 9.76H9C8.59 9.76 8.25 9.42 8.25 9.01C8.25 8.6 8.59 8.26 9 8.26H12C12.41 8.26 12.75 8.6 12.75 9.01C12.75 9.42 12.41 9.76 12 9.76Z'
        fill={fill ? '#251163' : '#292D32'}
      />
      <path
        d='M18.01 2V3.5C18.67 3.5 19.3 3.77 19.76 4.22C20.24 4.71 20.5 5.34 20.5 6V8.42C20.5 9.16 20.17 9.5 19.42 9.5H17.5V4.01C17.5 3.73 17.73 3.5 18.01 3.5V2ZM18.01 2C16.9 2 16 2.9 16 4.01V11H19.42C21 11 22 10 22 8.42V6C22 4.9 21.55 3.9 20.83 3.17C20.1 2.45 19.11 2.01 18.01 2C18.02 2 18.01 2 18.01 2Z'
        fill={fill ? '#251163' : '#292D32'}
      />
    </svg>
  ),
  ship: (fill) => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
    >
      <path
        d='M14 2.92V11.23C14 12.25 13.17 13.08 12.15 13.08H3C2.45 13.08 2 12.63 2 12.08V5.69C2 3.65 3.65 2 5.69 2H13.07C13.59 2 14 2.41 14 2.92Z'
        fill={fill ? '#251163' : '#292D32'}
      />
      <path
        d='M21.5 15.5C21.78 15.5 22 15.72 22 16V17C22 18.66 20.66 20 19 20C19 18.35 17.65 17 16 17C14.35 17 13 18.35 13 20H11C11 18.35 9.65 17 8 17C6.35 17 5 18.35 5 20C3.34 20 2 18.66 2 17V15C2 14.45 2.45 14 3 14H12.5C13.88 14 15 12.88 15 11.5V6C15 5.45 15.45 5 16 5H16.84C17.56 5 18.22 5.39 18.58 6.01L19.22 7.13C19.31 7.29 19.19 7.5 19 7.5C17.62 7.5 16.5 8.62 16.5 10V13C16.5 14.38 17.62 15.5 19 15.5H21.5Z'
        fill={fill ? '#251163' : '#292D32'}
      />
      <path
        d='M8 22C9.10457 22 10 21.1046 10 20C10 18.8954 9.10457 18 8 18C6.89543 18 6 18.8954 6 20C6 21.1046 6.89543 22 8 22Z'
        fill={fill ? '#251163' : '#292D32'}
      />
      <path
        d='M16 22C17.1046 22 18 21.1046 18 20C18 18.8954 17.1046 18 16 18C14.8954 18 14 18.8954 14 20C14 21.1046 14.8954 22 16 22Z'
        fill={fill ? '#251163' : '#292D32'}
      />
      <path
        d='M22 12.53V14H19C18.45 14 18 13.55 18 13V10C18 9.45 18.45 9 19 9H20.29L21.74 11.54C21.91 11.84 22 12.18 22 12.53Z'
        fill={fill ? '#251163' : '#292D32'}
      />
    </svg>
  ),
  addShipment: (fill) => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill={fill ? '#251163' : '#292D32'}
    >
      <image href={addShipmentIcon} width='24' height='24' />
    </svg>
  ),
  addLeg: (fill) => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill={fill ? '#251163' : '#292D32'}
    >
      <image href={addLegIcon} width='24' height='24' />
    </svg>
  ),
  track: (fill) => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
    >
      <path
        d='M11.9988 19.75H9.31875C8.15875 19.75 7.14875 19.05 6.74875 17.97C6.33875 16.89 6.63875 15.7 7.50875 14.93L15.4988 7.94C15.9788 7.52 15.9888 6.95 15.8488 6.56C15.6988 6.17 15.3188 5.75 14.6788 5.75H11.9988C11.5888 5.75 11.2488 5.41 11.2488 5C11.2488 4.59 11.5888 4.25 11.9988 4.25H14.6788C15.8388 4.25 16.8488 4.95 17.2488 6.03C17.6588 7.11 17.3588 8.3 16.4888 9.07L8.49875 16.06C8.01875 16.48 8.00875 17.05 8.14875 17.44C8.29875 17.83 8.67875 18.25 9.31875 18.25H11.9988C12.4088 18.25 12.7488 18.59 12.7488 19C12.7488 19.41 12.4088 19.75 11.9988 19.75Z'
        fill={fill ? '#251163' : '#292D32'}
      />
      <path
        d='M19.9987 15H16.9987C15.8987 15 14.9987 15.9 14.9987 17V20C14.9987 21.1 15.8987 22 16.9987 22H19.9987C21.0987 22 21.9987 21.1 21.9987 20V17C21.9987 15.9 21.0987 15 19.9987 15ZM18.5087 19.5C17.9587 19.5 17.5087 19.05 17.5087 18.5C17.5087 17.95 17.9487 17.5 18.5087 17.5H18.5187C19.0687 17.5 19.5187 17.95 19.5187 18.5C19.5187 19.05 19.0687 19.5 18.5087 19.5Z'
        fill={fill ? '#251163' : '#292D32'}
      />
      <path
        d='M5.46875 2C3.53875 2 1.96875 3.57 1.96875 5.5C1.96875 7.43 3.53875 9 5.46875 9C7.39875 9 8.96875 7.43 8.96875 5.5C8.96875 3.57 7.40875 2 5.46875 2ZM5.50875 6.5C4.95875 6.5 4.50875 6.05 4.50875 5.5C4.50875 4.95 4.94875 4.5 5.50875 4.5H5.51875C6.06875 4.5 6.51875 4.95 6.51875 5.5C6.51875 6.05 6.06875 6.5 5.50875 6.5Z'
        fill={fill ? '#251163' : '#292D32'}
      />
    </svg>
  ),
  shipments: (fill) => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
    >
      <path
        d='M20.21 7.81994L12.51 12.2799C12.2 12.4599 11.81 12.4599 11.49 12.2799L3.79 7.81994C3.24 7.49994 3.1 6.74994 3.52 6.27994C3.81 5.94994 4.14 5.67994 4.49 5.48994L9.91 2.48994C11.07 1.83994 12.95 1.83994 14.11 2.48994L19.53 5.48994C19.88 5.67994 20.21 5.95994 20.5 6.27994C20.9 6.74994 20.76 7.49994 20.21 7.81994Z'
        fill={fill ? '#251163' : '#292D32'}
      />
      <path
        d='M11.43 14.14V20.96C11.43 21.72 10.66 22.22 9.98 21.89C7.92 20.88 4.45 18.99 4.45 18.99C3.23 18.3 2.23 16.56 2.23 15.13V9.97C2.23 9.18 3.06 8.68 3.74 9.07L10.93 13.24C11.23 13.43 11.43 13.77 11.43 14.14Z'
        fill={fill ? '#251163' : '#292D32'}
      />
      <path
        d='M12.57 14.14V20.96C12.57 21.72 13.34 22.22 14.02 21.89C16.08 20.88 19.55 18.99 19.55 18.99C20.77 18.3 21.77 16.56 21.77 15.13V9.97C21.77 9.18 20.94 8.68 20.26 9.07L13.07 13.24C12.77 13.43 12.57 13.77 12.57 14.14Z'
        fill={fill ? '#251163' : '#292D32'}
      />
    </svg>
  ),
  legs: (fill) => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
    >
      <path
        d='M17.6 5.31003L11.95 2.27003C11.35 1.95003 10.64 1.95003 10.04 2.27003L4.4 5.31003C3.99 5.54003 3.73 5.98003 3.73 6.46003C3.73 6.95003 3.98 7.39003 4.4 7.61003L10.05 10.65C10.35 10.81 10.68 10.89 11 10.89C11.32 10.89 11.66 10.81 11.95 10.65L17.6 7.61003C18.01 7.39003 18.27 6.95003 18.27 6.46003C18.27 5.98003 18.01 5.54003 17.6 5.31003Z'
        fill={fill ? '#251163' : '#292D32'}
      />
      <path
        d='M9.12 11.7101L3.87 9.09009C3.46 8.88009 3 8.91009 2.61 9.14009C2.23 9.38009 2 9.79009 2 10.2401V15.2001C2 16.0601 2.48 16.8301 3.25 17.2201L8.5 19.8401C8.68 19.9301 8.88 19.9801 9.08 19.9801C9.31 19.9801 9.55 19.9101 9.76 19.7901C10.14 19.5501 10.37 19.1401 10.37 18.6901V13.7301C10.36 12.8701 9.88 12.1001 9.12 11.7101Z'
        fill={fill ? '#251163' : '#292D32'}
      />
      <path
        d='M20 10.2401V12.7001C19.52 12.5601 19.01 12.5001 18.5 12.5001C17.14 12.5001 15.81 12.9701 14.76 13.8101C13.32 14.9401 12.5 16.6501 12.5 18.5001C12.5 18.9901 12.56 19.4801 12.69 19.9501C12.54 19.9301 12.39 19.8701 12.25 19.7801C11.87 19.5501 11.64 19.1401 11.64 18.6901V13.7301C11.64 12.8701 12.12 12.1001 12.88 11.7101L18.13 9.09009C18.54 8.88009 19 8.91009 19.39 9.14009C19.77 9.38009 20 9.79009 20 10.2401Z'
        fill={fill ? '#251163' : '#292D32'}
      />
      <path
        d='M22.58 21.5L21.74 20.66C22.18 20 22.44 19.2 22.44 18.35C22.44 16.02 20.55 14.13 18.22 14.13C15.89 14.13 14 16.02 14 18.35C14 20.68 15.89 22.57 18.22 22.57C19.07 22.57 19.87 22.31 20.53 21.87L21.37 22.71C21.54 22.88 21.75 22.96 21.97 22.96C22.19 22.96 22.41 22.88 22.57 22.71C22.91 22.37 22.91 21.83 22.58 21.5Z'
        fill={fill ? '#251163' : '#292D32'}
      />
    </svg>
  ),
  overdue: (fill) => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
    >
      <path
        d='M16.75 3.56V2C16.75 1.59 16.41 1.25 16 1.25C15.59 1.25 15.25 1.59 15.25 2V3.5H8.75V2C8.75 1.59 8.41 1.25 8 1.25C7.59 1.25 7.25 1.59 7.25 2V3.56C4.55 3.81 3.24 5.42 3.04 7.81C3.02 8.1 3.26 8.34 3.54 8.34H20.46C20.75 8.34 20.99 8.09 20.96 7.81C20.76 5.42 19.45 3.81 16.75 3.56Z'
        fill={fill ? '#251163' : '#292D32'}
      />
      <path
        d='M20 9.83997H4C3.45 9.83997 3 10.29 3 10.84V17C3 20 4.5 22 8 22H16C19.5 22 21 20 21 17V10.84C21 10.29 20.55 9.83997 20 9.83997ZM9.21 18.21C9.16 18.25 9.11 18.3 9.06 18.33C9 18.37 8.94 18.4 8.88 18.42C8.82 18.45 8.76 18.47 8.7 18.48C8.63 18.49 8.57 18.5 8.5 18.5C8.37 18.5 8.24 18.47 8.12 18.42C7.99 18.37 7.89 18.3 7.79 18.21C7.61 18.02 7.5 17.76 7.5 17.5C7.5 17.24 7.61 16.98 7.79 16.79C7.89 16.7 7.99 16.63 8.12 16.58C8.3 16.5 8.5 16.48 8.7 16.52C8.76 16.53 8.82 16.55 8.88 16.58C8.94 16.6 9 16.63 9.06 16.67C9.11 16.71 9.16 16.75 9.21 16.79C9.39 16.98 9.5 17.24 9.5 17.5C9.5 17.76 9.39 18.02 9.21 18.21ZM9.21 14.71C9.02 14.89 8.76 15 8.5 15C8.24 15 7.98 14.89 7.79 14.71C7.61 14.52 7.5 14.26 7.5 14C7.5 13.74 7.61 13.48 7.79 13.29C8.07 13.01 8.51 12.92 8.88 13.08C9.01 13.13 9.12 13.2 9.21 13.29C9.39 13.48 9.5 13.74 9.5 14C9.5 14.26 9.39 14.52 9.21 14.71ZM12.71 18.21C12.52 18.39 12.26 18.5 12 18.5C11.74 18.5 11.48 18.39 11.29 18.21C11.11 18.02 11 17.76 11 17.5C11 17.24 11.11 16.98 11.29 16.79C11.66 16.42 12.34 16.42 12.71 16.79C12.89 16.98 13 17.24 13 17.5C13 17.76 12.89 18.02 12.71 18.21ZM12.71 14.71C12.66 14.75 12.61 14.79 12.56 14.83C12.5 14.87 12.44 14.9 12.38 14.92C12.32 14.95 12.26 14.97 12.2 14.98C12.13 14.99 12.07 15 12 15C11.74 15 11.48 14.89 11.29 14.71C11.11 14.52 11 14.26 11 14C11 13.74 11.11 13.48 11.29 13.29C11.38 13.2 11.49 13.13 11.62 13.08C11.99 12.92 12.43 13.01 12.71 13.29C12.89 13.48 13 13.74 13 14C13 14.26 12.89 14.52 12.71 14.71ZM16.21 18.21C16.02 18.39 15.76 18.5 15.5 18.5C15.24 18.5 14.98 18.39 14.79 18.21C14.61 18.02 14.5 17.76 14.5 17.5C14.5 17.24 14.61 16.98 14.79 16.79C15.16 16.42 15.84 16.42 16.21 16.79C16.39 16.98 16.5 17.24 16.5 17.5C16.5 17.76 16.39 18.02 16.21 18.21ZM16.21 14.71C16.16 14.75 16.11 14.79 16.06 14.83C16 14.87 15.94 14.9 15.88 14.92C15.82 14.95 15.76 14.97 15.7 14.98C15.63 14.99 15.56 15 15.5 15C15.24 15 14.98 14.89 14.79 14.71C14.61 14.52 14.5 14.26 14.5 14C14.5 13.74 14.61 13.48 14.79 13.29C14.89 13.2 14.99 13.13 15.12 13.08C15.3 13 15.5 12.98 15.7 13.02C15.76 13.03 15.82 13.05 15.88 13.08C15.94 13.1 16 13.13 16.06 13.17C16.11 13.21 16.16 13.25 16.21 13.29C16.39 13.48 16.5 13.74 16.5 14C16.5 14.26 16.39 14.52 16.21 14.71Z'
        fill={fill ? '#251163' : '#292D32'}
      />
    </svg>
  ),
  reports: (fill) => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
    >
      <path
        d='M16.19 2H7.81C4.17 2 2 4.17 2 7.81V16.18C2 19.83 4.17 22 7.81 22H16.18C19.82 22 21.99 19.83 21.99 16.19V7.81C22 4.17 19.83 2 16.19 2ZM13.33 17H10.66C10.25 17 9.91 16.66 9.91 16.25C9.91 15.84 10.25 15.5 10.66 15.5H13.33C13.74 15.5 14.08 15.84 14.08 16.25C14.08 16.66 13.75 17 13.33 17ZM16 12.75H8C7.59 12.75 7.25 12.41 7.25 12C7.25 11.59 7.59 11.25 8 11.25H16C16.41 11.25 16.75 11.59 16.75 12C16.75 12.41 16.41 12.75 16 12.75ZM18 8.5H6C5.59 8.5 5.25 8.16 5.25 7.75C5.25 7.34 5.59 7 6 7H18C18.41 7 18.75 7.34 18.75 7.75C18.75 8.16 18.41 8.5 18 8.5Z'
        fill={fill ? '#251163' : '#292D32'}
      />
    </svg>
  ),
  dangerousGoods: (fill) => (
    <svg
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M19.56 8.73996L18.21 7.15996C17.96 6.85996 17.75 6.29996 17.75 5.89996V4.19996C17.75 3.13996 16.88 2.26996 15.82 2.26996H14.12C13.72 2.26996 13.15 2.05996 12.85 1.80996L11.27 0.459956C10.58 -0.130044 9.45 -0.130044 8.76 0.459956L7.16 1.80996C6.86 2.05996 6.3 2.26996 5.9 2.26996H4.17C3.11 2.26996 2.24 3.13996 2.24 4.19996V5.89996C2.24 6.28996 2.04 6.84996 1.79 7.14996L0.440005 8.73996C-0.139995 9.43996 -0.139995 10.56 0.440005 11.24L1.79 12.83C2.04 13.12 2.24 13.69 2.24 14.08V15.79C2.24 16.85 3.11 17.72 4.17 17.72H5.91C6.3 17.72 6.87 17.93 7.17 18.18L8.75 19.53C9.44 20.12 10.57 20.12 11.26 19.53L12.84 18.18C13.14 17.93 13.7 17.72 14.1 17.72H15.8C16.86 17.72 17.73 16.85 17.73 15.79V14.09C17.73 13.69 17.94 13.13 18.19 12.83L19.54 11.25C20.15 10.57 20.15 9.43996 19.56 8.73996ZM9.25 6.12996C9.25 5.71996 9.59 5.37996 10 5.37996C10.41 5.37996 10.75 5.71996 10.75 6.12996V10.96C10.75 11.37 10.41 11.71 10 11.71C9.59 11.71 9.25 11.37 9.25 10.96V6.12996ZM10 14.87C9.45 14.87 9 14.42 9 13.87C9 13.32 9.44 12.87 10 12.87C10.55 12.87 11 13.32 11 13.87C11 14.42 10.56 14.87 10 14.87Z'
        fill={fill ? '#251163' : '#292D32'}
      />
    </svg>
  ),
  savedQuotes: (fill) => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
    >
      <path
        d='M15.78 2H8.22C4.44 2 3.5 3.01 3.5 7.04V18.3C3.5 20.96 4.96 21.59 6.73 19.69L6.74 19.68C7.56 18.81 8.81 18.88 9.52 19.83L10.53 21.18C11.34 22.25 12.65 22.25 13.46 21.18L14.47 19.83C15.19 18.87 16.44 18.8 17.26 19.68C19.04 21.58 20.49 20.95 20.49 18.29V7.04C20.5 3.01 19.56 2 15.78 2ZM15.66 14.53C15.51 14.68 15.32 14.75 15.13 14.75C14.94 14.75 14.75 14.68 14.6 14.53L13.86 13.79C13.28 14.17 12.58 14.4 11.83 14.4C9.79 14.4 8.13 12.74 8.13 10.7C8.13 8.66 9.78 7 11.83 7C13.88 7 15.53 8.66 15.53 10.7C15.53 11.45 15.3 12.15 14.92 12.73L15.66 13.47C15.95 13.76 15.95 14.24 15.66 14.53Z'
        fill={fill ? '#251163' : '#292D32'}
      />
    </svg>
  ),
  profiles: (fill) => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
    >
      <path
        d='M9 2C6.38 2 4.25 4.13 4.25 6.75C4.25 9.32 6.26 11.4 8.88 11.49C8.96 11.48 9.04 11.48 9.1 11.49C9.12 11.49 9.13 11.49 9.15 11.49C9.16 11.49 9.16 11.49 9.17 11.49C11.73 11.4 13.74 9.32 13.75 6.75C13.75 4.13 11.62 2 9 2Z'
        fill={fill ? '#251163' : '#292D32'}
      />
      <path
        d='M14.08 14.15C11.29 12.29 6.73999 12.29 3.92999 14.15C2.65999 15 1.95999 16.15 1.95999 17.38C1.95999 18.61 2.65999 19.75 3.91999 20.59C5.31999 21.53 7.15999 22 8.99999 22C10.84 22 12.68 21.53 14.08 20.59C15.34 19.74 16.04 18.6 16.04 17.36C16.03 16.13 15.34 14.99 14.08 14.15Z'
        fill={fill ? '#251163' : '#292D32'}
      />
      <path
        d='M19.99 7.33998C20.15 9.27998 18.77 10.98 16.86 11.21C16.85 11.21 16.85 11.21 16.84 11.21H16.81C16.75 11.21 16.69 11.21 16.64 11.23C15.67 11.28 14.78 10.97 14.11 10.4C15.14 9.47998 15.73 8.09998 15.61 6.59998C15.54 5.78998 15.26 5.04998 14.84 4.41998C15.22 4.22998 15.66 4.10998 16.11 4.06998C18.07 3.89998 19.82 5.35998 19.99 7.33998Z'
        fill={fill ? '#251163' : '#292D32'}
      />
      <path
        d='M21.99 16.59C21.91 17.56 21.29 18.4 20.25 18.97C19.25 19.52 17.99 19.78 16.74 19.75C17.46 19.1 17.88 18.29 17.96 17.43C18.06 16.19 17.47 15 16.29 14.05C15.62 13.52 14.84 13.1 13.99 12.79C16.2 12.15 18.98 12.58 20.69 13.96C21.61 14.7 22.08 15.63 21.99 16.59Z'
        fill={fill ? '#251163' : '#292D32'}
      />
    </svg>
  ),
  terms: (fill) => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
    >
      <path
        d='M12.6777 19.9571C12.9524 20.021 12.9776 20.3808 12.71 20.47L11.13 20.99C7.16001 22.27 5.07001 21.2 3.78001 17.23L2.50001 13.28C1.22001 9.31004 2.28001 7.21004 6.25001 5.93004L6.774 5.75651C7.17687 5.6231 7.56893 6.02716 7.45454 6.43583C7.39783 6.6384 7.34329 6.84981 7.29001 7.07004L6.31001 11.26C5.21001 15.97 6.82001 18.57 11.53 19.69L12.6777 19.9571Z'
        fill={fill ? '#251163' : '#292D32'}
      />
      <path
        d='M17.17 3.21001L15.5 2.82001C12.16 2.03001 10.17 2.68001 9 5.10001C8.7 5.71001 8.46 6.45001 8.26 7.30001L7.28 11.49C6.3 15.67 7.59 17.73 11.76 18.72L13.44 19.12C14.02 19.26 14.56 19.35 15.06 19.39C18.18 19.69 19.84 18.23 20.68 14.62L21.66 10.44C22.64 6.26001 21.36 4.19001 17.17 3.21001ZM15.29 13.33C15.2 13.67 14.9 13.89 14.56 13.89C14.5 13.89 14.44 13.88 14.37 13.87L11.46 13.13C11.06 13.03 10.82 12.62 10.92 12.22C11.02 11.82 11.43 11.58 11.83 11.68L14.74 12.42C15.15 12.52 15.39 12.93 15.29 13.33ZM18.22 9.95001C18.13 10.29 17.83 10.51 17.49 10.51C17.43 10.51 17.37 10.5 17.3 10.49L12.45 9.26001C12.05 9.16001 11.81 8.75001 11.91 8.35001C12.01 7.95001 12.42 7.71001 12.82 7.81001L17.67 9.04001C18.08 9.13001 18.32 9.54001 18.22 9.95001Z'
        fill={fill ? '#251163' : '#292D32'}
      />
    </svg>
  ),
  fees: (fill) => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
    >
      <path
        d='M14.85 3.95005V7.75005H13.35V3.95005C13.35 3.68005 13.11 3.55005 12.95 3.55005C12.9 3.55005 12.85 3.56005 12.8 3.58005L4.87 6.57005C4.34 6.77005 4 7.27005 4 7.84005V8.51005C3.09 9.19005 2.5 10.28 2.5 11.51V7.84005C2.5 6.65005 3.23 5.59005 4.34 5.17005L12.28 2.17005C12.5 2.09005 12.73 2.05005 12.95 2.05005C13.95 2.05005 14.85 2.86005 14.85 3.95005Z'
        fill={fill ? '#251163' : '#292D32'}
      />
      <path
        d='M21.5 14.5V15.5C21.5 15.77 21.29 15.99 21.01 16H19.55C19.02 16 18.54 15.61 18.5 15.09C18.47 14.78 18.59 14.49 18.79 14.29C18.97 14.1 19.22 14 19.49 14H21C21.29 14.01 21.5 14.23 21.5 14.5Z'
        fill={fill ? '#251163' : '#292D32'}
      />
      <path
        d='M19.48 12.95H20.5C21.05 12.95 21.5 12.5 21.5 11.95V11.51C21.5 9.44 19.81 7.75 17.74 7.75H6.26C5.41 7.75 4.63 8.03 4 8.51C3.09 9.19 2.5 10.28 2.5 11.51V18.24C2.5 20.31 4.19 22 6.26 22H17.74C19.81 22 21.5 20.31 21.5 18.24V18.05C21.5 17.5 21.05 17.05 20.5 17.05H19.63C18.67 17.05 17.75 16.46 17.5 15.53C17.29 14.77 17.54 14.04 18.04 13.55C18.41 13.17 18.92 12.95 19.48 12.95ZM14 12.75H7C6.59 12.75 6.25 12.41 6.25 12C6.25 11.59 6.59 11.25 7 11.25H14C14.41 11.25 14.75 11.59 14.75 12C14.75 12.41 14.41 12.75 14 12.75Z'
        fill={fill ? '#251163' : '#292D32'}
      />
    </svg>
  ),
  addresses: (fill) => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
    >
      <path
        d='M20.62 8.45C19.57 3.83 15.54 1.75 12 1.75C12 1.75 12 1.75 11.99 1.75C8.46 1.75 4.42 3.82 3.37 8.44C2.2 13.6 5.36 17.97 8.22 20.72C9.28 21.74 10.64 22.25 12 22.25C13.36 22.25 14.72 21.74 15.77 20.72C18.63 17.97 21.79 13.61 20.62 8.45ZM12 13.46C10.26 13.46 8.85 12.05 8.85 10.31C8.85 8.57 10.26 7.16 12 7.16C13.74 7.16 15.15 8.57 15.15 10.31C15.15 12.05 13.74 13.46 12 13.46Z'
        fill={fill ? '#251163' : '#292D32'}
      />
    </svg>
  ),
  contacts: (fill) => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
    >
      <path
        d='M18 2H6C4.34 2 3 3.33 3 4.97V15.88C3 17.52 4.34 18.85 6 18.85H6.76C7.56 18.85 8.32 19.16 8.88 19.72L10.59 21.41C11.37 22.18 12.64 22.18 13.42 21.41L15.13 19.72C15.69 19.16 16.46 18.85 17.25 18.85H18C19.66 18.85 21 17.52 21 15.88V4.97C21 3.33 19.66 2 18 2ZM12 5.75C13.29 5.75 14.33 6.79 14.33 8.08C14.33 9.37 13.29 10.41 12 10.41C10.71 10.41 9.67 9.36 9.67 8.08C9.67 6.79 10.71 5.75 12 5.75ZM14.68 15.06H9.32C8.51 15.06 8.04 14.16 8.49 13.49C9.17 12.48 10.49 11.8 12 11.8C13.51 11.8 14.83 12.48 15.51 13.49C15.96 14.16 15.48 15.06 14.68 15.06Z'
        fill={fill ? '#251163' : '#292D32'}
      />
    </svg>
  ),
  brokers: (fill) => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
    >
      <path
        d='M17.53 7.77C17.46 7.76 17.39 7.76 17.32 7.77C15.77 7.72 14.54 6.45 14.54 4.89C14.54 3.3 15.83 2 17.43 2C19.02 2 20.32 3.29 20.32 4.89C20.31 6.45 19.08 7.72 17.53 7.77Z'
        fill={fill ? '#251163' : '#292D32'}
      />
      <path
        d='M20.79 14.6999C19.67 15.4499 18.1 15.7299 16.65 15.5399C17.03 14.7199 17.23 13.8099 17.24 12.8499C17.24 11.8499 17.02 10.8999 16.6 10.0699C18.08 9.86991 19.65 10.1499 20.78 10.8999C22.36 11.9399 22.36 13.6499 20.79 14.6999Z'
        fill={fill ? '#251163' : '#292D32'}
      />
      <path
        d='M6.44 7.77C6.51 7.76 6.58 7.76 6.65 7.77C8.2 7.72 9.43 6.45 9.43 4.89C9.43 3.29 8.14 2 6.54 2C4.95 2 3.66 3.29 3.66 4.89C3.66 6.45 4.89 7.72 6.44 7.77Z'
        fill={fill ? '#251163' : '#292D32'}
      />
      <path
        d='M6.55 12.8501C6.55 13.8201 6.75999 14.7401 7.14 15.5701C5.73 15.7201 4.26 15.4201 3.18 14.7101C1.6 13.6601 1.6 11.9501 3.18 10.9001C4.25 10.1801 5.75999 9.8901 7.18 10.0501C6.77 10.8901 6.55 11.8401 6.55 12.8501Z'
        fill={fill ? '#251163' : '#292D32'}
      />
      <path
        d='M12.12 15.87C12.04 15.86 11.95 15.86 11.86 15.87C10.02 15.81 8.54999 14.3 8.54999 12.44C8.55999 10.54 10.09 9 12 9C13.9 9 15.44 10.54 15.44 12.44C15.43 14.3 13.97 15.81 12.12 15.87Z'
        fill={fill ? '#251163' : '#292D32'}
      />
      <path
        d='M8.86999 17.9399C7.35999 18.9499 7.35999 20.6099 8.86999 21.6099C10.59 22.7599 13.41 22.7599 15.13 21.6099C16.64 20.5999 16.64 18.9399 15.13 17.9399C13.42 16.7899 10.6 16.7899 8.86999 17.9399Z'
        fill={fill ? '#251163' : '#292D32'}
      />
    </svg>
  ),
  packages: (fill) => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
    >
      <path
        d='M22 9.75C21.59 9.75 21.25 9.41 21.25 9V7C21.25 4.42 19.58 2.75 17 2.75H7C4.42 2.75 2.75 4.42 2.75 7V9C2.75 9.41 2.41 9.75 2 9.75C1.59 9.75 1.25 9.41 1.25 9V7C1.25 3.56 3.56 1.25 7 1.25H17C20.44 1.25 22.75 3.56 22.75 7V9C22.75 9.41 22.41 9.75 22 9.75Z'
        fill={fill ? '#251163' : '#292D32'}
      />
      <path
        d='M17 22.75H7C3.56 22.75 1.25 20.44 1.25 17V15C1.25 14.59 1.59 14.25 2 14.25C2.41 14.25 2.75 14.59 2.75 15V17C2.75 19.58 4.42 21.25 7 21.25H17C19.58 21.25 21.25 19.58 21.25 17V15C21.25 14.59 21.59 14.25 22 14.25C22.41 14.25 22.75 14.59 22.75 15V17C22.75 20.44 20.44 22.75 17 22.75Z'
        fill={fill ? '#251163' : '#292D32'}
      />
      <path
        d='M16.4 8.20996L12.64 6.17996C12.24 5.96996 11.77 5.96996 11.37 6.17996L7.6 8.20996C7.33 8.35996 7.16 8.64996 7.16 8.96996C7.16 9.29996 7.33 9.58996 7.6 9.73996L11.36 11.77C11.56 11.88 11.78 11.93 12 11.93C12.22 11.93 12.44 11.88 12.64 11.77L16.4 9.73996C16.67 9.58996 16.84 9.29996 16.84 8.96996C16.84 8.64996 16.67 8.35996 16.4 8.20996Z'
        fill={fill ? '#251163' : '#292D32'}
      />
      <path
        d='M10.74 12.4699L7.24 10.7199C6.97 10.5899 6.66 10.5999 6.4 10.7599C6.15 10.9199 6 11.1899 6 11.4899V14.7999C6 15.3699 6.32 15.8899 6.83 16.1399L10.33 17.8899C10.45 17.9499 10.58 17.9799 10.72 17.9799C10.88 17.9799 11.03 17.9399 11.17 17.8499C11.43 17.6899 11.58 17.4199 11.58 17.1199V13.8099C11.57 13.2399 11.26 12.7299 10.74 12.4699Z'
        fill={fill ? '#251163' : '#292D32'}
      />
      <path
        d='M17.59 10.7599C17.33 10.5999 17.02 10.5899 16.75 10.7199L13.25 12.4699C12.74 12.7299 12.42 13.2399 12.42 13.8099V17.1199C12.42 17.4199 12.57 17.6899 12.83 17.8499C12.97 17.9399 13.12 17.9799 13.28 17.9799C13.41 17.9799 13.54 17.9499 13.67 17.8899L17.17 16.1399C17.68 15.8799 18 15.3699 18 14.7999V11.4899C18 11.1899 17.85 10.9199 17.59 10.7599Z'
        fill={fill ? '#251163' : '#292D32'}
      />
    </svg>
  ),
  //admin
  adminDashboard: (fill) => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
    >
      <path
        d='M14.19 0H5.81C2.17 0 0 2.17 0 5.81V14.18C0 17.83 2.17 20 5.81 20H14.18C17.82 20 19.99 17.83 19.99 14.19V5.81C20 2.17 17.83 0 14.19 0ZM7.91 14.19C7.91 14.83 7.39 15.35 6.74 15.35C6.1 15.35 5.58 14.83 5.58 14.19V10.93C5.58 10.29 6.1 9.77 6.74 9.77C7.39 9.77 7.91 10.29 7.91 10.93V14.19ZM14.42 14.19C14.42 14.83 13.9 15.35 13.26 15.35C12.61 15.35 12.09 14.83 12.09 14.19V5.81C12.09 5.17 12.61 4.65 13.26 4.65C13.9 4.65 14.42 5.17 14.42 5.81V14.19Z'
        fill={fill ? '#251163' : '#292D32'}
      />
    </svg>
  ),
  adminShipments: (fill) => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
    >
      <path
        d='M20.21 7.81994L12.51 12.2799C12.2 12.4599 11.81 12.4599 11.49 12.2799L3.79 7.81994C3.24 7.49994 3.1 6.74994 3.52 6.27994C3.81 5.94994 4.14 5.67994 4.49 5.48994L9.91 2.48994C11.07 1.83994 12.95 1.83994 14.11 2.48994L19.53 5.48994C19.88 5.67994 20.21 5.95994 20.5 6.27994C20.9 6.74994 20.76 7.49994 20.21 7.81994Z'
        fill={fill ? '#251163' : '#292D32'}
      />
      <path
        d='M11.43 14.1399V20.9599C11.43 21.7199 10.66 22.2199 9.98001 21.8899C7.92001 20.8799 4.45001 18.9899 4.45001 18.9899C3.23001 18.2999 2.23001 16.5599 2.23001 15.1299V9.96988C2.23001 9.17988 3.06001 8.67988 3.74001 9.06988L10.93 13.2399C11.23 13.4299 11.43 13.7699 11.43 14.1399Z'
        fill={fill ? '#251163' : '#292D32'}
      />
      <path
        d='M12.57 14.1399V20.9599C12.57 21.7199 13.34 22.2199 14.02 21.8899C16.08 20.8799 19.55 18.9899 19.55 18.9899C20.77 18.2999 21.77 16.5599 21.77 15.1299V9.96988C21.77 9.17988 20.94 8.67988 20.26 9.06988L13.07 13.2399C12.77 13.4299 12.57 13.7699 12.57 14.1399Z'
        fill={fill ? '#251163' : '#292D32'}
      />
    </svg>
  ),
  adminLegs: (fill) => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
    >
      <path
        d='M17.6 5.31003L11.95 2.27003C11.35 1.95003 10.64 1.95003 10.04 2.27003L4.40001 5.31003C3.99001 5.54003 3.73001 5.98003 3.73001 6.46003C3.73001 6.95003 3.98001 7.39003 4.40001 7.61003L10.05 10.65C10.35 10.81 10.68 10.89 11 10.89C11.32 10.89 11.66 10.81 11.95 10.65L17.6 7.61003C18.01 7.39003 18.27 6.95003 18.27 6.46003C18.27 5.98003 18.01 5.54003 17.6 5.31003Z'
        fill={fill ? '#251163' : '#292D32'}
      />
      <path
        d='M9.12 11.7101L3.87 9.09009C3.46 8.88009 3 8.91009 2.61 9.14009C2.23 9.38009 2 9.79009 2 10.2401V15.2001C2 16.0601 2.48 16.8301 3.25 17.2201L8.5 19.8401C8.68 19.9301 8.88 19.9801 9.08 19.9801C9.31 19.9801 9.55 19.9101 9.76 19.7901C10.14 19.5501 10.37 19.1401 10.37 18.6901V13.7301C10.36 12.8701 9.88 12.1001 9.12 11.7101Z'
        fill={fill ? '#251163' : '#292D32'}
      />
      <path
        d='M20 10.2401V12.7001C19.52 12.5601 19.01 12.5001 18.5 12.5001C17.14 12.5001 15.81 12.9701 14.76 13.8101C13.32 14.9401 12.5 16.6501 12.5 18.5001C12.5 18.9901 12.56 19.4801 12.69 19.9501C12.54 19.9301 12.39 19.8701 12.25 19.7801C11.87 19.5501 11.64 19.1401 11.64 18.6901V13.7301C11.64 12.8701 12.12 12.1001 12.88 11.7101L18.13 9.09009C18.54 8.88009 19 8.91009 19.39 9.14009C19.77 9.38009 20 9.79009 20 10.2401Z'
        fill={fill ? '#251163' : '#292D32'}
      />
      <path
        d='M22.58 21.4999L21.74 20.6599C22.18 19.9999 22.44 19.1999 22.44 18.3499C22.44 16.0199 20.55 14.1299 18.22 14.1299C15.89 14.1299 14 16.0199 14 18.3499C14 20.6799 15.89 22.5699 18.22 22.5699C19.07 22.5699 19.87 22.3099 20.53 21.8699L21.37 22.7099C21.54 22.8799 21.75 22.9599 21.97 22.9599C22.19 22.9599 22.41 22.8799 22.57 22.7099C22.91 22.3699 22.91 21.8299 22.58 21.4999Z'
        fill={fill ? '#251163' : '#292D32'}
      />
    </svg>
  ),
  adminSavedQuotes: (fill) => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
    >
      <path
        d='M17 4.96V12.08C17 14.07 15.59 14.84 13.86 13.8L12.54 13C12.24 12.82 11.76 12.82 11.46 13L10.14 13.8C8.41 14.84 7 14.07 7 12.08V4.99C7.01 3 8.01 2 10 2H14C15.98 2 16.98 2.99 17 4.96Z'
        fill={fill ? '#251163' : '#292D32'}
      />
      <path
        d='M22 11.9001V14.9301C22 19.9801 20 22.0001 15 22.0001H9C4 22.0001 2 19.9801 2 14.9301V11.9001C2 9.2101 2.57 7.3801 3.85 6.2601C4.5 5.7101 5.5 6.1901 5.5 7.0401V12.0801C5.5 13.5701 6.11 14.7701 7.17 15.3701C8.24 15.9801 9.6 15.8701 10.92 15.0801L12 14.4301L13.09 15.0801C13.83 15.5301 14.6 15.7601 15.32 15.7601C15.86 15.7601 16.37 15.6301 16.83 15.3701C17.89 14.7701 18.5 13.5701 18.5 12.0801V7.0301C18.5 6.1801 19.51 5.7001 20.15 6.2601C21.43 7.3801 22 9.2101 22 11.9001Z'
        fill={fill ? '#251163' : '#292D32'}
      />
    </svg>
  ),
  adminOverdue: (fill) => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
    >
      <path
        d='M16.75 3.56V2C16.75 1.59 16.41 1.25 16 1.25C15.59 1.25 15.25 1.59 15.25 2V3.5H8.74999V2C8.74999 1.59 8.40999 1.25 7.99999 1.25C7.58999 1.25 7.24999 1.59 7.24999 2V3.56C4.54999 3.81 3.23999 5.42 3.03999 7.81C3.01999 8.1 3.25999 8.34 3.53999 8.34H20.46C20.75 8.34 20.99 8.09 20.96 7.81C20.76 5.42 19.45 3.81 16.75 3.56Z'
        fill={fill ? '#251163' : '#292D32'}
      />
      <path
        d='M20 9.84009H4C3.45 9.84009 3 10.2901 3 10.8401V17.0001C3 20.0001 4.5 22.0001 8 22.0001H16C19.5 22.0001 21 20.0001 21 17.0001V10.8401C21 10.2901 20.55 9.84009 20 9.84009ZM9.21 18.2101C9.16 18.2501 9.11 18.3001 9.06 18.3301C9 18.3701 8.94 18.4001 8.88 18.4201C8.82 18.4501 8.76 18.4701 8.7 18.4801C8.63 18.4901 8.57 18.5001 8.5 18.5001C8.37 18.5001 8.24 18.4701 8.12 18.4201C7.99 18.3701 7.89 18.3001 7.79 18.2101C7.61 18.0201 7.5 17.7601 7.5 17.5001C7.5 17.2401 7.61 16.9801 7.79 16.7901C7.89 16.7001 7.99 16.6301 8.12 16.5801C8.3 16.5001 8.5 16.4801 8.7 16.5201C8.76 16.5301 8.82 16.5501 8.88 16.5801C8.94 16.6001 9 16.6301 9.06 16.6701C9.11 16.7101 9.16 16.7501 9.21 16.7901C9.39 16.9801 9.5 17.2401 9.5 17.5001C9.5 17.7601 9.39 18.0201 9.21 18.2101ZM9.21 14.7101C9.02 14.8901 8.76 15.0001 8.5 15.0001C8.24 15.0001 7.98 14.8901 7.79 14.7101C7.61 14.5201 7.5 14.2601 7.5 14.0001C7.5 13.7401 7.61 13.4801 7.79 13.2901C8.07 13.0101 8.51 12.9201 8.88 13.0801C9.01 13.1301 9.12 13.2001 9.21 13.2901C9.39 13.4801 9.5 13.7401 9.5 14.0001C9.5 14.2601 9.39 14.5201 9.21 14.7101ZM12.71 18.2101C12.52 18.3901 12.26 18.5001 12 18.5001C11.74 18.5001 11.48 18.3901 11.29 18.2101C11.11 18.0201 11 17.7601 11 17.5001C11 17.2401 11.11 16.9801 11.29 16.7901C11.66 16.4201 12.34 16.4201 12.71 16.7901C12.89 16.9801 13 17.2401 13 17.5001C13 17.7601 12.89 18.0201 12.71 18.2101ZM12.71 14.7101C12.66 14.7501 12.61 14.7901 12.56 14.8301C12.5 14.8701 12.44 14.9001 12.38 14.9201C12.32 14.9501 12.26 14.9701 12.2 14.9801C12.13 14.9901 12.07 15.0001 12 15.0001C11.74 15.0001 11.48 14.8901 11.29 14.7101C11.11 14.5201 11 14.2601 11 14.0001C11 13.7401 11.11 13.4801 11.29 13.2901C11.38 13.2001 11.49 13.1301 11.62 13.0801C11.99 12.9201 12.43 13.0101 12.71 13.2901C12.89 13.4801 13 13.7401 13 14.0001C13 14.2601 12.89 14.5201 12.71 14.7101ZM16.21 18.2101C16.02 18.3901 15.76 18.5001 15.5 18.5001C15.24 18.5001 14.98 18.3901 14.79 18.2101C14.61 18.0201 14.5 17.7601 14.5 17.5001C14.5 17.2401 14.61 16.9801 14.79 16.7901C15.16 16.4201 15.84 16.4201 16.21 16.7901C16.39 16.9801 16.5 17.2401 16.5 17.5001C16.5 17.7601 16.39 18.0201 16.21 18.2101ZM16.21 14.7101C16.16 14.7501 16.11 14.7901 16.06 14.8301C16 14.8701 15.94 14.9001 15.88 14.9201C15.82 14.9501 15.76 14.9701 15.7 14.9801C15.63 14.9901 15.56 15.0001 15.5 15.0001C15.24 15.0001 14.98 14.8901 14.79 14.7101C14.61 14.5201 14.5 14.2601 14.5 14.0001C14.5 13.7401 14.61 13.4801 14.79 13.2901C14.89 13.2001 14.99 13.1301 15.12 13.0801C15.3 13.0001 15.5 12.9801 15.7 13.0201C15.76 13.0301 15.82 13.0501 15.88 13.0801C15.94 13.1001 16 13.1301 16.06 13.1701C16.11 13.2101 16.16 13.2501 16.21 13.2901C16.39 13.4801 16.5 13.7401 16.5 14.0001C16.5 14.2601 16.39 14.5201 16.21 14.7101Z'
        fill={fill ? '#251163' : '#292D32'}
      />
    </svg>
  ),
  adminReports: (fill) => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
    >
      <path
        d='M16 2H8C4 2 2 4 2 8V21C2 21.55 2.45 22 3 22H16C20 22 22 20 22 16V8C22 4 20 2 16 2ZM14 15.25H7C6.59 15.25 6.25 14.91 6.25 14.5C6.25 14.09 6.59 13.75 7 13.75H14C14.41 13.75 14.75 14.09 14.75 14.5C14.75 14.91 14.41 15.25 14 15.25ZM17 10.25H7C6.59 10.25 6.25 9.91 6.25 9.5C6.25 9.09 6.59 8.75 7 8.75H17C17.41 8.75 17.75 9.09 17.75 9.5C17.75 9.91 17.41 10.25 17 10.25Z'
        fill={fill ? '#251163' : '#292D32'}
      />
    </svg>
  ),
  adminManualShipment: (fill) => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
    >
      <path
        d='M21.5 15.5C21.78 15.5 22 15.72 22 16V17C22 18.66 20.66 20 19 20C19 18.35 17.65 17 16 17C14.35 17 13 18.35 13 20H11C11 18.35 9.65 17 8 17C6.35 17 5 18.35 5 20C3.34 20 2 18.66 2 17V15C2 14.45 2.45 14 3 14H12.5C13.88 14 15 12.88 15 11.5V6C15 5.45 15.45 5 16 5H16.84C17.56 5 18.22 5.39 18.58 6.01L19.22 7.13C19.31 7.29 19.19 7.5 19 7.5C17.62 7.5 16.5 8.62 16.5 10V13C16.5 14.38 17.62 15.5 19 15.5H21.5Z'
        fill={fill ? '#251163' : '#292D32'}
      />
      <path
        d='M8 22C9.10457 22 10 21.1046 10 20C10 18.8954 9.10457 18 8 18C6.89543 18 6 18.8954 6 20C6 21.1046 6.89543 22 8 22Z'
        fill={fill ? '#251163' : '#292D32'}
      />
      <path
        d='M16 22C17.1046 22 18 21.1046 18 20C18 18.8954 17.1046 18 16 18C14.8954 18 14 18.8954 14 20C14 21.1046 14.8954 22 16 22Z'
        fill={fill ? '#251163' : '#292D32'}
      />
      <path
        d='M22 12.53V14H19C18.45 14 18 13.55 18 13V10C18 9.45 18.45 9 19 9H20.29L21.74 11.54C21.91 11.84 22 12.18 22 12.53Z'
        fill={fill ? '#251163' : '#292D32'}
      />
      <path
        d='M13.08 2H5.69C3.65 2 2 3.65 2 5.69V12.08C2 12.63 2.45 13.08 3 13.08H12.15C13.17 13.08 14 12.25 14 11.23V2.92C14 2.41 13.59 2 13.08 2ZM9.38 7.91C9.38 8.17 9.24 8.42 9.02 8.55L7.77 9.3C7.64 9.38 7.51 9.41 7.38 9.41C7.13 9.41 6.88 9.28 6.74 9.05C6.52 8.69 6.64 8.23 6.99 8.02L7.88 7.49V6.41C7.88 6 8.22 5.66 8.63 5.66C9.04 5.66 9.38 6 9.38 6.41V7.91Z'
        fill={fill ? '#251163' : '#292D32'}
      />
    </svg>
  ),
  adminPackageTypes: (fill) => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
    >
      <path
        d='M16.19 2.33008H7.81C4.17 2.33008 2 4.51008 2 8.15008V16.5201C2 20.1601 4.17 22.3301 7.81 22.3301H16.18C19.82 22.3301 21.99 20.1601 21.99 16.5201V8.15008C22 4.51008 19.83 2.33008 16.19 2.33008ZM11.57 17.1201C11.57 17.4201 11.42 17.6901 11.16 17.8501C11.02 17.9401 10.87 17.9801 10.71 17.9801C10.58 17.9801 10.45 17.9501 10.32 17.8901L6.82 16.1401C6.32 15.8801 6 15.3701 6 14.8001V11.4901C6 11.1901 6.15 10.9201 6.41 10.7601C6.67 10.6001 6.98 10.5901 7.25 10.7201L10.75 12.4701C11.26 12.7301 11.58 13.2401 11.58 13.8101V17.1201H11.57ZM11.36 11.7701L7.6 9.74008C7.33 9.59008 7.16 9.30008 7.16 8.97008C7.16 8.65008 7.33 8.35008 7.6 8.20008L11.36 6.17008C11.76 5.96008 12.23 5.96008 12.63 6.17008L16.39 8.20008C16.66 8.35008 16.83 8.64008 16.83 8.97008C16.83 9.30008 16.66 9.59008 16.39 9.74008L12.63 11.7701C12.43 11.8801 12.21 11.9301 11.99 11.9301C11.77 11.9301 11.56 11.8801 11.36 11.7701ZM18 14.8001C18 15.3701 17.68 15.8901 17.17 16.1401L13.67 17.8901C13.55 17.9501 13.42 17.9801 13.28 17.9801C13.12 17.9801 12.97 17.9401 12.83 17.8501C12.57 17.6901 12.42 17.4201 12.42 17.1201V13.8101C12.42 13.2401 12.74 12.7201 13.25 12.4701L16.75 10.7201C17.02 10.5901 17.33 10.6001 17.59 10.7601C17.85 10.9201 18 11.1901 18 11.4901V14.8001Z'
        fill={fill ? '#251163' : '#292D32'}
      />
    </svg>
  ),
  adminWebhooks: (fill) => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
    >
      <path
        d='M19.37 4.89012L13.51 2.28012C12.65 1.90012 11.35 1.90012 10.49 2.28012L4.62999 4.89012C3.14999 5.55012 2.92999 6.45012 2.92999 6.93012C2.92999 7.41012 3.14999 8.31012 4.62999 8.97012L10.49 11.5801C10.92 11.7701 11.46 11.8701 12 11.8701C12.54 11.8701 13.08 11.7701 13.51 11.5801L19.37 8.97012C20.85 8.31012 21.07 7.41012 21.07 6.93012C21.07 6.45012 20.86 5.55012 19.37 4.89012Z'
        fill={fill ? '#251163' : '#292D32'}
      />
      <path
        d='M12 17.04C11.62 17.04 11.24 16.96 10.89 16.81L4.15001 13.81C3.12001 13.35 2.32001 12.12 2.32001 10.99C2.32001 10.58 2.65001 10.25 3.06001 10.25C3.47001 10.25 3.80001 10.58 3.80001 10.99C3.80001 11.53 4.25001 12.23 4.75001 12.45L11.49 15.45C11.81 15.59 12.18 15.59 12.5 15.45L19.24 12.45C19.74 12.23 20.19 11.54 20.19 10.99C20.19 10.58 20.52 10.25 20.93 10.25C21.34 10.25 21.67 10.58 21.67 10.99C21.67 12.11 20.87 13.35 19.84 13.81L13.1 16.81C12.76 16.96 12.38 17.04 12 17.04Z'
        fill={fill ? '#251163' : '#292D32'}
      />
      <path
        d='M12 22C11.62 22 11.24 21.92 10.89 21.77L4.15001 18.77C3.04001 18.28 2.32001 17.17 2.32001 15.95C2.32001 15.54 2.65001 15.21 3.06001 15.21C3.47001 15.21 3.80001 15.54 3.80001 15.95C3.80001 16.58 4.17001 17.15 4.75001 17.41L11.49 20.41C11.81 20.55 12.18 20.55 12.5 20.41L19.24 17.41C19.81 17.16 20.19 16.58 20.19 15.95C20.19 15.54 20.52 15.21 20.93 15.21C21.34 15.21 21.67 15.54 21.67 15.95C21.67 17.17 20.95 18.27 19.84 18.77L13.1 21.77C12.76 21.92 12.38 22 12 22Z'
        fill={fill ? '#251163' : '#292D32'}
      />
    </svg>
  ),

  adminSetLanes: (fill) => (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M9.15002 7.48999C8.59002 7.48999 8.15002 7.93999 8.15002 8.48999C8.15002 9.03999 8.60002 9.48999 9.15002 9.48999C9.70002 9.48999 10.15 9.03999 10.15 8.48999C10.15 7.93999 9.70002 7.48999 9.15002 7.48999Z'
        fill='#292D32'
      />
      <path
        d='M21.46 5.04C20.62 3.09 18.77 2 16.19 2H7.81C4.6 2 2 4.6 2 7.81V16.19C2 18.77 3.09 20.62 5.04 21.46C5.23 21.54 5.45 21.49 5.59 21.35L21.35 5.59C21.5 5.44 21.55 5.22 21.46 5.04ZM10.53 12.24C10.14 12.62 9.63 12.8 9.12 12.8C8.61 12.8 8.1 12.61 7.71 12.24C6.69 11.28 5.57 9.75 6 7.93C6.38 6.28 7.84 5.54 9.12 5.54C10.4 5.54 11.86 6.28 12.24 7.94C12.66 9.75 11.54 11.28 10.53 12.24Z'
        fill='#292D32'
      />
      <path
        d='M19.47 20.53C19.69 20.75 19.66 21.11 19.39 21.26C18.51 21.75 17.44 22 16.19 22H7.81002C7.52002 22 7.40002 21.66 7.60002 21.46L13.64 15.42C13.84 15.22 14.15 15.22 14.35 15.42L19.47 20.53Z'
        fill='#292D32'
      />
      <path
        d='M22 7.8099V16.1899C22 17.4399 21.75 18.5199 21.26 19.3899C21.11 19.6599 20.75 19.6799 20.53 19.4699L15.41 14.3499C15.21 14.1499 15.21 13.8399 15.41 13.6399L21.45 7.5999C21.66 7.3999 22 7.5199 22 7.8099Z'
        fill='#292D32'
      />
    </svg>
  ),

  //accounts
  accounts: (fill) => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
    >
      <path
        d='M16.19 2H7.81C4.17 2 2 4.17 2 7.81V16.19C2 19 3.29 20.93 5.56 21.66C6.22 21.89 6.98 22 7.81 22H16.19C17.02 22 17.78 21.89 18.44 21.66C20.71 20.93 22 19 22 16.19V7.81C22 4.17 19.83 2 16.19 2ZM20.5 16.19C20.5 18.33 19.66 19.68 17.97 20.24C17 18.33 14.7 16.97 12 16.97C9.3 16.97 7.01 18.32 6.03 20.24H6.02C4.35 19.7 3.5 18.34 3.5 16.2V7.81C3.5 4.99 4.99 3.5 7.81 3.5H16.19C19.01 3.5 20.5 4.99 20.5 7.81V16.19Z'
        fill={fill ? '#251163' : '#292D32'}
      />
      <path
        d='M12 8C10.02 8 8.42001 9.6 8.42001 11.58C8.42001 13.56 10.02 15.17 12 15.17C13.98 15.17 15.58 13.56 15.58 11.58C15.58 9.6 13.98 8 12 8Z'
        fill={fill ? '#251163' : '#292D32'}
      />
    </svg>
  ),
  accountsMarkups: (fill) => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
    >
      <path
        d='M15.78 2H8.22C4.44 2 3.5 3.01 3.5 7.04V18.3C3.5 20.96 4.96 21.59 6.73 19.69L6.74 19.68C7.56 18.81 8.81 18.88 9.52 19.83L10.53 21.18C11.34 22.25 12.65 22.25 13.46 21.18L14.47 19.83C15.19 18.87 16.44 18.8 17.26 19.68C19.04 21.58 20.49 20.95 20.49 18.29V7.04C20.5 3.01 19.56 2 15.78 2ZM9 7C9.55 7 10 7.45 10 8C10 8.55 9.56 9 9 9C8.44 9 8 8.55 8 8C8 7.45 8.44 7 9 7ZM15 14C14.44 14 14 13.55 14 13C14 12.45 14.45 12 15 12C15.55 12 16 12.45 16 13C16 13.55 15.56 14 15 14ZM15.9 7.59L9.17 14.32C9.02 14.47 8.83 14.54 8.64 14.54C8.45 14.54 8.26 14.47 8.11 14.32C7.82 14.03 7.82 13.55 8.11 13.26L14.84 6.53C15.13 6.24 15.61 6.24 15.9 6.53C16.19 6.82 16.19 7.3 15.9 7.59Z'
        fill={fill ? '#251163' : '#292D32'}
      />
    </svg>
  ),
  accountsExchangeRates: (fill) => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
    >
      <path
        d='M22 15C22 18.87 18.87 22 15 22L16.05 20.25'
        stroke='#292D32'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M2 9C2 5.13 5.13 2 9 2L7.95 3.75'
        stroke='#292D32'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M22 4.2V4.31C22 4.59 21.78 4.81 21.5 4.81H12.5C12.22 4.81 12 4.59 12 4.31V4.2C12 2.44 12.44 2 14.22 2H19.78C21.56 2 22 2.44 22 4.2Z'
        fill={fill ? '#251163' : '#292D32'}
      />
      <path
        d='M12.5 5.81006C12.22 5.81006 12 6.03006 12 6.31006V7.31006V8.30006C12 10.0601 12.44 10.5001 14.22 10.5001H19.78C21.56 10.5001 22 10.0601 22 8.30006V7.31006V6.31006C22 6.03006 21.78 5.81006 21.5 5.81006H12.5Z'
        fill={fill ? '#251163' : '#292D32'}
      />
      <path
        d='M12 15.7V15.81C12 16.09 11.78 16.31 11.5 16.31H2.5C2.22 16.31 2 16.09 2 15.81V15.7C2 13.94 2.44 13.5 4.22 13.5H9.78C11.56 13.5 12 13.94 12 15.7Z'
        fill={fill ? '#251163' : '#292D32'}
      />
      <path
        d='M2.5 17.3101C2.22 17.3101 2 17.5301 2 17.8101V18.8101V19.8001C2 21.5601 2.44 22.0001 4.22 22.0001H9.78C11.56 22.0001 12 21.5601 12 19.8001V18.8101V17.8101C12 17.5301 11.78 17.3101 11.5 17.3101H2.5Z'
        fill={fill ? '#251163' : '#292D32'}
      />
    </svg>
  ),
  accountsPromoCodes: (fill) => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
    >
      <path
        d='M11.25 8.08008V10.9401L10.24 10.5901C9.73001 10.4101 9.42001 10.2401 9.42001 9.37008C9.42001 8.66008 9.95001 8.08008 10.6 8.08008H11.25Z'
        fill={fill ? '#251163' : '#292D32'}
      />
      <path
        d='M14.58 14.6301C14.58 15.3401 14.05 15.9201 13.4 15.9201H12.75V13.0601L13.76 13.4101C14.27 13.5901 14.58 13.7601 14.58 14.6301Z'
        fill={fill ? '#251163' : '#292D32'}
      />
      <path
        d='M16.19 2H7.81C4.17 2 2 4.17 2 7.81V16.19C2 19.83 4.17 22 7.81 22H16.19C19.83 22 22 19.83 22 16.19V7.81C22 4.17 19.83 2 16.19 2ZM14.26 12C15.04 12.27 16.08 12.84 16.08 14.63C16.08 16.17 14.88 17.42 13.4 17.42H12.75V18C12.75 18.41 12.41 18.75 12 18.75C11.59 18.75 11.25 18.41 11.25 18V17.42H10.89C9.25 17.42 7.92 16.03 7.92 14.33C7.92 13.92 8.25 13.58 8.67 13.58C9.08 13.58 9.42 13.92 9.42 14.33C9.42 15.21 10.08 15.92 10.89 15.92H11.25V12.53L9.74 12C8.96 11.73 7.92 11.16 7.92 9.37C7.92 7.83 9.12 6.58 10.6 6.58H11.25V6C11.25 5.59 11.59 5.25 12 5.25C12.41 5.25 12.75 5.59 12.75 6V6.58H13.11C14.75 6.58 16.08 7.97 16.08 9.67C16.08 10.08 15.75 10.42 15.33 10.42C14.92 10.42 14.58 10.08 14.58 9.67C14.58 8.79 13.92 8.08 13.11 8.08H12.75V11.47L14.26 12Z'
        fill={fill ? '#251163' : '#292D32'}
      />
    </svg>
  ),
  //carriers
  carriers: (fill) => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
    >
      <path
        d='M19.3125 9.00006C19.3125 9.30756 19.0575 9.56256 18.75 9.56256H5.25C4.9425 9.56256 4.6875 9.30756 4.6875 9.00006C4.6875 8.69256 4.9425 8.43756 5.25 8.43756H6.015L6.3 7.08006C6.57 5.76756 7.1325 4.56006 9.3675 4.56006H14.6325C16.8675 4.56006 17.43 5.76756 17.7 7.08006L17.985 8.43756H18.75C19.0575 8.43756 19.3125 8.69256 19.3125 9.00006Z'
        fill={fill ? '#251163' : '#292D32'}
      />
      <path
        d='M19.6349 13.245C19.5224 12.0075 19.1924 10.6875 16.7849 10.6875H7.21494C4.80744 10.6875 4.48494 12.0075 4.36494 13.245L3.94494 17.8125C3.89244 18.3825 4.07994 18.9525 4.46994 19.38C4.86744 19.815 5.42994 20.0625 6.02994 20.0625H7.43994C8.65494 20.0625 8.88744 19.365 9.03744 18.9075L9.18744 18.4575C9.35994 17.94 9.40494 17.8125 10.0799 17.8125H13.9199C14.5949 17.8125 14.6174 17.8875 14.8124 18.4575L14.9624 18.9075C15.1124 19.365 15.3449 20.0625 16.5599 20.0625H17.9699C18.5624 20.0625 19.1324 19.815 19.5299 19.38C19.9199 18.9525 20.1074 18.3825 20.0549 17.8125L19.6349 13.245ZM9.74994 14.8125H7.49994C7.19244 14.8125 6.93744 14.5575 6.93744 14.25C6.93744 13.9425 7.19244 13.6875 7.49994 13.6875H9.74994C10.0574 13.6875 10.3124 13.9425 10.3124 14.25C10.3124 14.5575 10.0574 14.8125 9.74994 14.8125ZM16.4999 14.8125H14.2499C13.9424 14.8125 13.6874 14.5575 13.6874 14.25C13.6874 13.9425 13.9424 13.6875 14.2499 13.6875H16.4999C16.8074 13.6875 17.0624 13.9425 17.0624 14.25C17.0624 14.5575 16.8074 14.8125 16.4999 14.8125Z'
        fill={fill ? '#251163' : '#292D32'}
      />
    </svg>
  ),
  carriersFuelSurcharge: (fill) => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
    >
      <path
        d='M5.2995 10.2147C4.56245 11.2278 4.12003 12.4251 4.02118 13.6741C3.92232 14.9231 4.17089 16.1751 4.73938 17.2916C5.30788 18.4081 6.17414 19.3456 7.24233 20.0003C8.31053 20.6551 9.53902 21.0016 10.7919 21.0015H13.2081C14.461 21.0016 15.6895 20.6551 16.7577 20.0003C17.8259 19.3456 18.6921 18.4081 19.2606 17.2916C19.8291 16.1751 20.0777 14.9231 19.9788 13.6741C19.88 12.4251 19.4375 11.2278 18.7005 10.2147L12 1L5.2995 10.2147ZM11.2459 18.2513C10.2944 18.2522 9.36055 17.9939 8.54463 17.5043C7.72871 17.0147 7.0615 16.3122 6.6146 15.4721C6.48967 15.2379 6.4629 14.9636 6.54017 14.7097C6.61744 14.4557 6.79243 14.2429 7.02663 14.118C7.26083 13.9931 7.53507 13.9663 7.78901 14.0435C8.04296 14.1208 8.2558 14.2958 8.38073 14.53C8.65674 15.0503 9.06936 15.4854 9.5742 15.7887C10.079 16.0919 10.657 16.2518 11.2459 16.2511C11.5112 16.2511 11.7656 16.3565 11.9531 16.5441C12.1407 16.7316 12.246 16.986 12.246 17.2512C12.246 17.5164 12.1407 17.7708 11.9531 17.9584C11.7656 18.1459 11.5112 18.2513 11.2459 18.2513Z'
        fill={fill ? '#251163' : '#292D32'}
      />
    </svg>
  ),
  carriersPickupRestrictions: (fill) => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
    >
      <path
        d='M21.76 15.92L15.36 4.4C14.5 2.85 13.31 2 12 2C10.69 2 9.50001 2.85 8.64001 4.4L2.24001 15.92C1.43001 17.39 1.34001 18.8 1.99001 19.91C2.64001 21.02 3.92001 21.63 5.60001 21.63H18.4C20.08 21.63 21.36 21.02 22.01 19.91C22.66 18.8 22.57 17.38 21.76 15.92ZM11.25 9C11.25 8.59 11.59 8.25 12 8.25C12.41 8.25 12.75 8.59 12.75 9V14C12.75 14.41 12.41 14.75 12 14.75C11.59 14.75 11.25 14.41 11.25 14V9ZM12.71 17.71C12.66 17.75 12.61 17.79 12.56 17.83C12.5 17.87 12.44 17.9 12.38 17.92C12.32 17.95 12.26 17.97 12.19 17.98C12.13 17.99 12.06 18 12 18C11.94 18 11.87 17.99 11.8 17.98C11.74 17.97 11.68 17.95 11.62 17.92C11.56 17.9 11.5 17.87 11.44 17.83C11.39 17.79 11.34 17.75 11.29 17.71C11.11 17.52 11 17.26 11 17C11 16.74 11.11 16.48 11.29 16.29C11.34 16.25 11.39 16.21 11.44 16.17C11.5 16.13 11.56 16.1 11.62 16.08C11.68 16.05 11.74 16.03 11.8 16.02C11.93 15.99 12.07 15.99 12.19 16.02C12.26 16.03 12.32 16.05 12.38 16.08C12.44 16.1 12.5 16.13 12.56 16.17C12.61 16.21 12.66 16.25 12.71 16.29C12.89 16.48 13 16.74 13 17C13 17.26 12.89 17.52 12.71 17.71Z'
        fill={fill ? '#251163' : '#292D32'}
      />
    </svg>
  ),
  carriersRatesheets: (fill) => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
    >
      <path
        d='M11.94 2.21008L9.53001 7.82008H7.12001C6.72001 7.82008 6.33001 7.85007 5.95001 7.93007L6.95001 5.53008L6.99001 5.44008L7.05001 5.28008C7.08001 5.21008 7.10001 5.15007 7.13001 5.10008C8.29001 2.41007 9.59001 1.57008 11.94 2.21008Z'
        fill={fill ? '#251163' : '#292D32'}
      />
      <path
        d='M18.73 8.09002L18.71 8.08002C18.11 7.91002 17.5 7.82002 16.88 7.82002H10.62L12.87 2.59002L12.9 2.52002C13.04 2.57002 13.19 2.64002 13.34 2.69002L15.55 3.62002C16.78 4.13002 17.64 4.66002 18.17 5.30002C18.26 5.42002 18.34 5.53002 18.42 5.66002C18.51 5.80002 18.58 5.94002 18.62 6.09002C18.66 6.18002 18.69 6.26002 18.71 6.35002C18.86 6.86002 18.87 7.44002 18.73 8.09002Z'
        fill={fill ? '#251163' : '#292D32'}
      />
      <path
        d='M12.52 17.6601H12.77C13.07 17.6601 13.32 17.3901 13.32 17.0601C13.32 16.6401 13.2 16.5801 12.94 16.4801L12.52 16.3301V17.6601Z'
        fill={fill ? '#251163' : '#292D32'}
      />
      <path
        d='M18.29 9.52007C17.84 9.39007 17.37 9.32007 16.88 9.32007H7.11999C6.43999 9.32007 5.79999 9.45007 5.19999 9.71007C3.45999 10.4601 2.23999 12.1901 2.23999 14.2001V16.1501C2.23999 16.3901 2.25999 16.6201 2.28999 16.8601C2.50999 20.0401 4.20999 21.7401 7.38999 21.9501C7.61999 21.9801 7.84999 22.0001 8.09999 22.0001H15.9C19.6 22.0001 21.55 20.2401 21.74 16.7401C21.75 16.5501 21.76 16.3501 21.76 16.1501V14.2001C21.76 11.9901 20.29 10.1301 18.29 9.52007ZM13.28 15.5001C13.74 15.6601 14.36 16.0001 14.36 17.0601C14.36 17.9701 13.65 18.7001 12.77 18.7001H12.52V18.9201C12.52 19.2101 12.29 19.4401 12 19.4401C11.71 19.4401 11.48 19.2101 11.48 18.9201V18.7001H11.39C10.43 18.7001 9.63999 17.8901 9.63999 16.8901C9.63999 16.6001 9.86999 16.3701 10.16 16.3701C10.45 16.3701 10.68 16.6001 10.68 16.8901C10.68 17.3101 11 17.6601 11.39 17.6601H11.48V15.9701L10.72 15.7001C10.26 15.5401 9.63999 15.2001 9.63999 14.1401C9.63999 13.2301 10.35 12.5001 11.23 12.5001H11.48V12.2801C11.48 11.9901 11.71 11.7601 12 11.7601C12.29 11.7601 12.52 11.9901 12.52 12.2801V12.5001H12.61C13.57 12.5001 14.36 13.3101 14.36 14.3101C14.36 14.6001 14.13 14.8301 13.84 14.8301C13.55 14.8301 13.32 14.6001 13.32 14.3101C13.32 13.8901 13 13.5401 12.61 13.5401H12.52V15.2301L13.28 15.5001Z'
        fill={fill ? '#251163' : '#292D32'}
      />
      <path
        d='M10.68 14.14C10.68 14.56 10.8 14.62 11.06 14.72L11.48 14.87V13.54H11.23C10.92 13.54 10.68 13.81 10.68 14.14Z'
        fill={fill ? '#251163' : '#292D32'}
      />
    </svg>
  ),
  carriersPort: (fill) => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
    >
      <path
        d='M18.02 12.33L16.8 11.11C16.51 10.86 16.34 10.49 16.33 10.08C16.31 9.63 16.49 9.18 16.82 8.85L18.02 7.65C19.06 6.61 19.45 5.61 19.12 4.82C18.8 4.04 17.81 3.61 16.35 3.61H5.89999V2.75C5.89999 2.34 5.55999 2 5.14999 2C4.73999 2 4.39999 2.34 4.39999 2.75V21.25C4.39999 21.66 4.73999 22 5.14999 22C5.55999 22 5.89999 21.66 5.89999 21.25V16.37H16.35C17.79 16.37 18.76 15.93 19.09 15.14C19.42 14.35 19.04 13.36 18.02 12.33Z'
        fill={fill ? '#251163' : '#292D32'}
      />
    </svg>
  ),
  carriersSailings: (fill) => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
    >
      <path
        d='M12.6724 0.0796195C12.4304 -0.0379422 12.2284 0.0981624 12.2284 0.366875V14.5326C15.0401 13.3122 17.1533 10.5065 17.1533 7.23483C17.1529 4.08594 15.32 1.36639 12.6724 0.0796195Z'
        fill={fill ? '#251163' : '#292D32'}
      />
      <path
        d='M10.942 3.28788L3.94788 14.533H11.2043L11.1996 3.36152C11.1996 3.09196 11.0846 3.05922 10.942 3.28788Z'
        fill={fill ? '#251163' : '#292D32'}
      />
      <path
        d='M0.109521 16.763L0.906228 18.6208C1.22363 19.3624 2.1353 19.9632 2.94192 19.9632H17.0582C17.8648 19.9632 18.776 19.362 19.0938 18.6208L19.8906 16.763C20.208 16.021 19.8122 15.4207 19.0052 15.4207H0.995393C0.187931 15.4207 -0.207879 16.0214 0.109521 16.763Z'
        fill={fill ? '#251163' : '#292D32'}
      />
    </svg>
  ),
  devApis: (fill) => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
    >
      <path
        d='M11 18V21C11 21.55 10.55 22 10 22C9.45 22 9 21.55 9 21V18H11Z'
        fill={fill ? '#251163' : '#292D32'}
      />
      <path
        d='M15 18V21C15 21.55 14.55 22 14 22C13.45 22 13 21.55 13 21V18H15Z'
        fill={fill ? '#251163' : '#292D32'}
      />
      <path
        d='M17 11V16C17 17.1 16.1 18 15 18H9C7.9 18 7 17.1 7 16V11C7 9.9 7.9 9 9 9H15C16.1 9 17 9.9 17 11Z'
        fill={fill ? '#251163' : '#292D32'}
      />
      <path
        d='M5 11V15C5 15.55 4.55 16 4 16C3.45 16 3 15.55 3 15V11C3 10.45 3.45 10 4 10C4.55 10 5 10.45 5 11Z'
        fill={fill ? '#251163' : '#292D32'}
      />
      <path
        d='M21 11V15C21 15.55 20.55 16 20 16C19.45 16 19 15.55 19 15V11C19 10.45 19.45 10 20 10C20.55 10 21 10.45 21 11Z'
        fill={fill ? '#251163' : '#292D32'}
      />
      <path
        d='M9.59998 7.60001H14.4C15.28 7.60001 16 6.88 16 6C16 3.79 14.21 2 12 2C9.79 2 8 3.79 8 6C8 6.88 8.71998 7.60001 9.59998 7.60001Z'
        fill={fill ? '#251163' : '#292D32'}
      />
    </svg>
  ),
  devErrorCodes: (fill) => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
    >
      <path
        d='M14.6622 1.85445C14.9748 1.64605 15.0592 1.22372 14.8508 0.911129C14.6425 0.598549 14.2201 0.514082 13.9076 0.722469L11.2635 2.48519C10.7955 2.29824 10.2848 2.19542 9.75007 2.19542C9.21532 2.19542 8.7046 2.29826 8.2366 2.48525L5.59242 0.722469C5.27983 0.514082 4.8575 0.598549 4.6491 0.911129C4.44072 1.22372 4.52518 1.64605 4.83777 1.85445L6.97799 3.28126C6.34728 3.86519 5.90135 4.64584 5.73767 5.52569C6.1323 5.42395 6.54607 5.36984 6.97248 5.36984H12.5277C12.9541 5.36984 13.3679 5.42395 13.7625 5.52569C13.5988 4.6458 13.1529 3.86511 12.5221 3.28117L14.6622 1.85445Z'
        fill={fill ? '#251163' : '#292D32'}
      />
      <path
        d='M0 12.1723C0 11.7966 0.304554 11.492 0.680233 11.492H3.40116V10.3016C3.40116 9.54366 3.63729 8.84085 4.03999 8.26273L1.78802 7.36178C1.43923 7.22224 1.26959 6.82635 1.40913 6.47754C1.54868 6.12874 1.94457 5.95911 2.29337 6.09865L5.13815 7.23677C5.67426 6.91522 6.30174 6.73036 6.97238 6.73036H12.5276C13.1982 6.73036 13.8258 6.91522 14.3619 7.23677L17.2066 6.09865C17.5554 5.95911 17.9513 6.12874 18.0908 6.47754C18.2304 6.82635 18.0608 7.22224 17.712 7.36178L15.4601 8.26273C15.8628 8.84085 16.0988 9.54366 16.0988 10.3016V11.492H18.8198C19.1954 11.492 19.5 11.7966 19.5 12.1723C19.5 12.5479 19.1954 12.8525 18.8198 12.8525H16.0988V13.0792C16.0988 14.1501 15.8337 15.159 15.3655 16.044L17.712 16.9827C18.0608 17.1223 18.2304 17.5182 18.0908 17.867C17.9513 18.2157 17.5554 18.3854 17.2066 18.2458L14.5831 17.1963C13.5569 18.3998 12.089 19.2153 10.4302 19.3921V13.0792C10.4302 12.7035 10.1257 12.399 9.75 12.399C9.37433 12.399 9.06977 12.7035 9.06977 13.0792V19.3921C7.41099 19.2153 5.9431 18.3998 4.91686 17.1963L2.29337 18.2458C1.94457 18.3854 1.54868 18.2157 1.40913 17.867C1.26959 17.5182 1.43923 17.1223 1.78802 16.9827L4.13447 16.044C3.66628 15.159 3.40116 14.1501 3.40116 13.0792V12.8525H0.680233C0.304554 12.8525 0 12.5479 0 12.1723Z'
        fill={fill ? '#251163' : '#292D32'}
      />
    </svg>
  ),
  devPermissions: (fill) => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
    >
      <path
        d='M15.2 7.16L7.20001 3.7V2.75C7.20001 2.34 6.86001 2 6.45001 2C6.04001 2 5.70001 2.34 5.70001 2.75V21.25C5.70001 21.66 6.04001 22 6.45001 22C6.86001 22 7.20001 21.66 7.20001 21.25V17.29L15.42 13.23C15.42 13.23 15.42 13.23 15.43 13.23C17.09 12.37 17.98 11.26 17.93 10.09C17.88 8.92 16.91 7.88 15.2 7.16Z'
        fill={fill ? '#251163' : '#292D32'}
      />
    </svg>
  ),
  devTiers: (fill) => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
    >
      <path
        d='M21.25 12.75C21.67 12.75 22 12.41 22 12C22 11.58 21.67 11.25 21.25 11.25H20V9.05H21.25C21.67 9.05 22 8.72 22 8.3C22 7.89 21.67 7.55 21.25 7.55H19.77C19.29 5.96 18.04 4.71 16.45 4.23V2.75C16.45 2.34 16.11 2 15.7 2C15.29 2 14.95 2.34 14.95 2.75V4H12.75V2.75C12.75 2.34 12.41 2 12 2C11.59 2 11.25 2.34 11.25 2.75V4H9.06V2.75C9.06 2.34 8.72 2 8.31 2C7.89 2 7.56 2.34 7.56 2.75V4.23C5.96 4.71 4.71 5.96 4.23 7.55H2.75C2.34 7.55 2 7.89 2 8.3C2 8.72 2.34 9.05 2.75 9.05H4V11.25H2.75C2.34 11.25 2 11.58 2 12C2 12.41 2.34 12.75 2.75 12.75H4V14.95H2.75C2.34 14.95 2 15.28 2 15.7C2 16.11 2.34 16.45 2.75 16.45H4.23C4.7 18.04 5.96 19.29 7.56 19.77V21.25C7.56 21.66 7.89 22 8.31 22C8.72 22 9.06 21.66 9.06 21.25V20H11.26V21.25C11.26 21.66 11.59 22 12.01 22C12.42 22 12.76 21.66 12.76 21.25V20H14.95V21.25C14.95 21.66 15.29 22 15.7 22C16.11 22 16.45 21.66 16.45 21.25V19.77C18.04 19.29 19.29 18.04 19.77 16.45H21.25C21.67 16.45 22 16.11 22 15.7C22 15.28 21.67 14.95 21.25 14.95H20V12.75H21.25ZM17.26 14.26C17.26 15.91 15.91 17.26 14.26 17.26H9.74C8.09 17.26 6.74 15.91 6.74 14.26V9.74C6.74 8.09 8.09 6.74 9.74 6.74H14.26C15.91 6.74 17.26 8.09 17.26 9.74V14.26Z'
        fill={fill ? '#251163' : '#292D32'}
      />
      <path
        d='M10.02 16.25H13.99C15.24 16.25 16.26 15.24 16.26 13.98V10.01C16.26 8.75999 15.25 7.73999 13.99 7.73999H10.02C8.77 7.73999 7.75 8.74999 7.75 10.01V13.98C7.75 15.24 8.76 16.25 10.02 16.25Z'
        fill={fill ? '#251163' : '#292D32'}
      />
    </svg>
  ),
  project: (fill) => (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M22 4.85005V16.7401C22 17.7101 21.21 18.6001 20.24 18.7201L19.93 18.7601C18.29 18.9801 15.98 19.6601 14.12 20.4401C13.47 20.7101 12.75 20.2201 12.75 19.5101V5.60005C12.75 5.23005 12.96 4.89005 13.29 4.71005C15.12 3.72005 17.89 2.84005 19.77 2.68005H19.83C21.03 2.68005 22 3.65005 22 4.85005Z'
        fill={fill ? '#251163' : '#292D32'}
      />
      <path
        d='M10.71 4.71005C8.88 3.72005 6.11 2.84005 4.23 2.68005H4.16C2.96 2.68005 1.99 3.65005 1.99 4.85005V16.7401C1.99 17.7101 2.78 18.6001 3.75 18.7201L4.06 18.7601C5.7 18.9801 8.01 19.6601 9.87 20.4401C10.52 20.7101 11.24 20.2201 11.24 19.5101V5.60005C11.24 5.22005 11.04 4.89005 10.71 4.71005ZM5 7.74005H7.25C7.66 7.74005 8 8.08005 8 8.49005C8 8.91005 7.66 9.24005 7.25 9.24005H5C4.59 9.24005 4.25 8.91005 4.25 8.49005C4.25 8.08005 4.59 7.74005 5 7.74005ZM8 12.2401H5C4.59 12.2401 4.25 11.9101 4.25 11.4901C4.25 11.0801 4.59 10.7401 5 10.7401H8C8.41 10.7401 8.75 11.0801 8.75 11.4901C8.75 11.9101 8.41 12.2401 8 12.2401Z'
        fill={fill ? '#251163' : '#292D32'}
      />
    </svg>
  ),
  job: (fill) => (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M21.09 6.98002C20.24 6.04002 18.82 5.57002 16.76 5.57002H16.52V5.53002C16.52 3.85002 16.52 1.77002 12.76 1.77002H11.24C7.47998 1.77002 7.47998 3.86002 7.47998 5.53002V5.58002H7.23998C5.16998 5.58002 3.75998 6.05002 2.90998 6.99002C1.91998 8.09002 1.94998 9.57002 2.04998 10.58L2.05998 10.65L2.13743 11.4633C2.1517 11.6131 2.23236 11.7484 2.35825 11.8307C2.59806 11.9877 2.9994 12.2464 3.23998 12.38C3.37998 12.47 3.52998 12.55 3.67998 12.63C5.38998 13.57 7.26998 14.2 9.17998 14.51C9.26998 15.45 9.67998 16.55 11.87 16.55C14.06 16.55 14.49 15.46 14.56 14.49C16.6 14.16 18.57 13.45 20.35 12.41C20.41 12.38 20.45 12.35 20.5 12.32C20.8967 12.0958 21.3083 11.8195 21.6834 11.5489C21.7965 11.4673 21.8687 11.3413 21.8841 11.2028L21.9 11.06L21.95 10.59C21.96 10.53 21.96 10.48 21.97 10.41C22.05 9.40002 22.03 8.02002 21.09 6.98002ZM13.09 13.83C13.09 14.89 13.09 15.05 11.86 15.05C10.63 15.05 10.63 14.86 10.63 13.84V12.58H13.09V13.83ZM8.90998 5.57002V5.53002C8.90998 3.83002 8.90998 3.20002 11.24 3.20002H12.76C15.09 3.20002 15.09 3.84002 15.09 5.53002V5.58002H8.90998V5.57002Z'
        fill={fill ? '#251163' : '#292D32'}
      />
      <path
        d='M20.8735 13.7341C21.2271 13.5659 21.6344 13.8462 21.599 14.2361L21.24 18.19C21.03 20.19 20.21 22.23 15.81 22.23H8.19003C3.79003 22.23 2.97003 20.19 2.76003 18.2L2.41932 14.4521C2.38427 14.0667 2.78223 13.7867 3.13487 13.9463C4.27428 14.4618 6.37742 15.3764 7.6766 15.7166C7.8409 15.7597 7.9738 15.8773 8.04574 16.0311C8.65271 17.3292 9.96914 18.02 11.87 18.02C13.7521 18.02 15.0852 17.3026 15.6942 16.0013C15.7662 15.8474 15.8992 15.7298 16.0636 15.6865C17.4432 15.3235 19.6818 14.3012 20.8735 13.7341Z'
        fill={fill ? '#251163' : '#292D32'}
      />
    </svg>
  ),
  lmsLineItem: (fill) => (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fill={fill ? '#251163' : '#292D32'}
        d='M19.24 5.58006H18.84L15.46 2.20006C15.19 1.93006 14.75 1.93006 14.47 2.20006C14.2 2.47006 14.2 2.91006 14.47 3.19006L16.86 5.58006H7.14L9.53 3.19006C9.8 2.92006 9.8 2.48006 9.53 2.20006C9.26 1.93006 8.82 1.93006 8.54 2.20006L5.17 5.58006H4.77C3.87 5.58006 2 5.58006 2 8.14006C2 9.11006 2.2 9.75006 2.62 10.1701C2.86 10.4201 3.15 10.5501 3.46 10.6201C3.75 10.6901 4.06 10.7001 4.36 10.7001H19.64C19.95 10.7001 20.24 10.6801 20.52 10.6201C21.36 10.4201 22 9.82006 22 8.14006C22 5.58006 20.13 5.58006 19.24 5.58006Z'
      />
      <path
        fill={fill ? '#251163' : '#292D32'}
        d='M19.05 12H4.87C4.25 12 3.78 12.55 3.88 13.16L4.72 18.3C5 20.02 5.75 22 9.08 22H14.69C18.06 22 18.66 20.31 19.02 18.42L20.03 13.19C20.15 12.57 19.68 12 19.05 12ZM12 19.5C9.66 19.5 7.75 17.59 7.75 15.25C7.75 14.84 8.09 14.5 8.5 14.5C8.91 14.5 9.25 14.84 9.25 15.25C9.25 16.77 10.48 18 12 18C13.52 18 14.75 16.77 14.75 15.25C14.75 14.84 15.09 14.5 15.5 14.5C15.91 14.5 16.25 14.84 16.25 15.25C16.25 17.59 14.34 19.5 12 19.5Z'
      />
    </svg>
  ),
  lmsItems: (fill) => (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M19.24 5.58006H18.84L15.46 2.20006C15.19 1.93006 14.75 1.93006 14.47 2.20006C14.2 2.47006 14.2 2.91006 14.47 3.19006L16.86 5.58006H7.14L9.53 3.19006C9.8 2.92006 9.8 2.48006 9.53 2.20006C9.26 1.93006 8.82 1.93006 8.54 2.20006L5.17 5.58006H4.77C3.87 5.58006 2 5.58006 2 8.14006C2 9.11006 2.2 9.75006 2.62 10.1701C2.86 10.4201 3.15 10.5501 3.46 10.6201C3.75 10.6901 4.06 10.7001 4.36 10.7001H19.64C19.95 10.7001 20.24 10.6801 20.52 10.6201C21.36 10.4201 22 9.82006 22 8.14006C22 5.58006 20.13 5.58006 19.24 5.58006Z'
        fill={fill ? '#251163' : '#292D32'}
      />
      <path
        d='M19.05 12H4.87C4.25 12 3.78 12.55 3.88 13.16L4.72 18.3C5 20.02 5.75 22 9.08 22H14.69C18.06 22 18.66 20.31 19.02 18.42L20.03 13.19C20.15 12.57 19.68 12 19.05 12ZM10.61 18.45C10.61 18.84 10.3 19.15 9.92 19.15C9.53 19.15 9.22 18.84 9.22 18.45V15.15C9.22 14.77 9.53 14.45 9.92 14.45C10.3 14.45 10.61 14.77 10.61 15.15V18.45ZM14.89 18.45C14.89 18.84 14.58 19.15 14.19 19.15C13.81 19.15 13.49 18.84 13.49 18.45V15.15C13.49 14.77 13.81 14.45 14.19 14.45C14.58 14.45 14.89 14.77 14.89 15.15V18.45Z'
        fill={fill ? '#251163' : '#292D32'}
      />
    </svg>
  ),
  lmsManifest: (fill) => (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M7.8 22.15C5.15 22.15 2.99 20 2.99 17.34V14.5C2.99 13.83 3.65 13.38 4.28 13.6C4.54 13.69 4.8 13.75 5.07 13.79C5.19 13.81 5.31 13.83 5.43 13.83C5.58 13.85 5.74 13.86 5.89 13.86C7 13.86 8.1 13.45 8.97 12.74C9.8 13.45 10.87 13.86 12.01 13.86C13.15 13.86 14.21 13.47 15.04 12.75C15.9 13.45 16.98 13.86 18.08 13.86C18.25 13.86 18.43 13.85 18.59 13.83C18.71 13.82 18.81 13.81 18.92 13.79C19.22 13.75 19.49 13.67 19.76 13.58C20.38 13.37 21.03 13.83 21.03 14.48V17.34C21.03 19.99 18.88 22.15 16.22 22.15H7.8Z'
        fill={fill ? '#251163' : '#292D32'}
      />
      <path
        d='M21.98 8.58998L21.7 5.92998C21.3 3.02998 19.98 1.84998 17.17 1.84998H6.82C4 1.84998 2.69 3.02998 2.28 5.95998L2.02 8.59998C1.92 9.62998 2.2 10.63 2.81 11.41C3.54 12.36 4.66 12.9 5.91 12.9C7.12 12.9 8.28 12.29 9.02 11.32C9.67 12.29 10.78 12.9 12.02 12.9C13.26 12.9 14.35 12.32 15.01 11.36C15.75 12.31 16.9 12.9 18.09 12.9C19.37 12.9 20.52 12.33 21.24 11.33C21.82 10.56 22.08 9.58998 21.98 8.58998ZM13.5 7.72998H10.5C10.09 7.72998 9.75 7.39998 9.75 6.97998C9.75 6.56998 10.09 6.22998 10.5 6.22998H13.5C13.91 6.22998 14.25 6.56998 14.25 6.97998C14.25 7.39998 13.91 7.72998 13.5 7.72998Z'
        fill={fill ? '#251163' : '#292D32'}
      />
    </svg>
  ),
  lmsConsolidation: (fill) => (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M22 5V7C22 8.83 21.17 9.82 19.5 9.97C19.34 9.99 19.17 10 19 10H5C4.83 10 4.66 9.99 4.5 9.97C2.83 9.82 2 8.83 2 7V5C2 3 3 2 5 2H19C21 2 22 3 22 5Z'
        fill={fill ? '#251163' : '#292D32'}
      />
      <path
        d='M5.5 11.25C4.95 11.25 4.5 11.7 4.5 12.25V19C4.5 21 5 22 7.5 22H16.5C19 22 19.5 21 19.5 19V12.25C19.5 11.7 19.05 11.25 18.5 11.25H5.5ZM13.82 15.75H10.18C9.77 15.75 9.43 15.41 9.43 15C9.43 14.59 9.77 14.25 10.18 14.25H13.82C14.23 14.25 14.57 14.59 14.57 15C14.57 15.41 14.23 15.75 13.82 15.75Z'
        fill={fill ? '#251163' : '#292D32'}
      />
    </svg>
  ),
  lmsReports: (fill) => (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M16.19 2H7.81C4.17 2 2 4.17 2 7.81V16.18C2 19.83 4.17 22 7.81 22H16.18C19.82 22 21.99 19.83 21.99 16.19V7.81C22 4.17 19.83 2 16.19 2ZM13.33 17H10.66C10.25 17 9.91 16.66 9.91 16.25C9.91 15.84 10.25 15.5 10.66 15.5H13.33C13.74 15.5 14.08 15.84 14.08 16.25C14.08 16.66 13.75 17 13.33 17ZM16 12.75H8C7.59 12.75 7.25 12.41 7.25 12C7.25 11.59 7.59 11.25 8 11.25H16C16.41 11.25 16.75 11.59 16.75 12C16.75 12.41 16.41 12.75 16 12.75ZM18 8.5H6C5.59 8.5 5.25 8.16 5.25 7.75C5.25 7.34 5.59 7 6 7H18C18.41 7 18.75 7.34 18.75 7.75C18.75 8.16 18.41 8.5 18 8.5Z'
        fill={fill ? '#251163' : '#292D32'}
      />
    </svg>
  ),
  warehouseHome: (fill) => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 -960 960 960'
      fill={fill ? '#251163' : '#292D32'}
    >
      <path d='M240-200h120v-240h240v240h120v-360L480-740 240-560v360Zm-80 80v-480l320-240 320 240v480H520v-240h-80v240H160Zm320-350Z' />
    </svg>
  ),
  warehouseOnhandDashboard: (fill) => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 -960 960 960'
      fill={fill ? '#251163' : '#292D32'}
    >
      <path d='M600-800H360v280h240v-280Zm200 0H680v280h120v-280ZM575-440H320v240h222q21 0 40.5-7t35.5-21l166-137q-8-8-18-12t-21-6q-17-3-33 1t-30 15l-108 87H400v-80h146l44-36q5-3 7.5-8t2.5-11q0-10-7.5-17.5T575-440Zm-335 0h-80v280h80v-280Zm40 0v-360q0-33 23.5-56.5T360-880h440q33 0 56.5 23.5T880-800v280q0 33-23.5 56.5T800-440H280ZM240-80h-80q-33 0-56.5-23.5T80-160v-280q0-33 23.5-56.5T160-520h415q85 0 164 29t127 98l27 41-223 186q-27 23-60 34.5T542-120H309q-11 18-29 29t-40 11Z' />
    </svg>
  ),
  warehouseInboundDashboard: (fill?: boolean) => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      height='24px'
      viewBox='0 -960 960 960'
      width='24px'
      fill={fill ? '#251163' : '#292D32'}
    >
      <path d='m480-320 56-56-63-64h167v-80H473l63-64-56-56-160 160 160 160ZM200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h168q13-36 43.5-58t68.5-22q38 0 68.5 22t43.5 58h168q33 0 56.5 23.5T840-760v560q0 33-23.5 56.5T760-120H200Zm0-80h560v-560H200v560Zm280-590q13 0 21.5-8.5T510-820q0-13-8.5-21.5T480-850q-13 0-21.5 8.5T450-820q0 13 8.5 21.5T480-790ZM200-200v-560 560Z' />
    </svg>
  ),
  warehouseOutboundDashboard: (fill?: boolean) => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      height='24px'
      viewBox='0 -960 960 960'
      width='24px'
      fill={fill ? '#251163' : '#292D32'}
    >
      <path d='m720-120-56-57 63-63H480v-80h247l-63-64 56-56 160 160-160 160Zm120-400h-80v-240h-80v120H280v-120h-80v560h200v80H200q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h167q11-35 43-57.5t70-22.5q40 0 71.5 22.5T594-840h166q33 0 56.5 23.5T840-760v240ZM480-760q17 0 28.5-11.5T520-800q0-17-11.5-28.5T480-840q-17 0-28.5 11.5T440-800q0 17 11.5 28.5T480-760Z' />
    </svg>
  ),
  warehouseLineItems: (fill) => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      height='24px'
      viewBox='0 -960 960 960'
      width='24px'
      fill={fill ? '#251163' : '#292D32'}
    >
      <path d='M320-280q17 0 28.5-11.5T360-320q0-17-11.5-28.5T320-360q-17 0-28.5 11.5T280-320q0 17 11.5 28.5T320-280Zm0-160q17 0 28.5-11.5T360-480q0-17-11.5-28.5T320-520q-17 0-28.5 11.5T280-480q0 17 11.5 28.5T320-440Zm0-160q17 0 28.5-11.5T360-640q0-17-11.5-28.5T320-680q-17 0-28.5 11.5T280-640q0 17 11.5 28.5T320-600Zm120 320h240v-80H440v80Zm0-160h240v-80H440v80Zm0-160h240v-80H440v80ZM200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760v560q0 33-23.5 56.5T760-120H200Zm0-80h560v-560H200v560Zm0-560v560-560Z' />
    </svg>
  ),
  warehouseAcceptance: (fill) => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      height='24px'
      viewBox='0 -960 960 960'
      width='24px'
      fill={fill ? '#251163' : '#292D32'}
    >
      <path d='M620-163 450-333l56-56 114 114 226-226 56 56-282 282Zm220-397h-80v-200h-80v120H280v-120h-80v560h240v80H200q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h167q11-35 43-57.5t70-22.5q40 0 71.5 22.5T594-840h166q33 0 56.5 23.5T840-760v200ZM480-760q17 0 28.5-11.5T520-800q0-17-11.5-28.5T480-840q-17 0-28.5 11.5T440-800q0 17 11.5 28.5T480-760Z' />
    </svg>
  ),
  warehouseReceiveShipments: (fill) => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      height='24px'
      viewBox='0 -960 960 960'
      width='24px'
      fill={fill ? '#251163' : '#292D32'}
    >
      <path d='M680-80q-83 0-141.5-58.5T480-280q0-83 58.5-141.5T680-480q83 0 141.5 58.5T880-280q0 83-58.5 141.5T680-80Zm67-105 28-28-75-75v-112h-40v128l87 87Zm-547 65q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h167q11-35 43-57.5t70-22.5q40 0 71.5 22.5T594-840h166q33 0 56.5 23.5T840-760v250q-18-13-38-22t-42-16v-212h-80v120H280v-120h-80v560h212q7 22 16 42t22 38H200Zm280-640q17 0 28.5-11.5T520-800q0-17-11.5-28.5T480-840q-17 0-28.5 11.5T440-800q0 17 11.5 28.5T480-760Z' />
    </svg>
  ),
  warehouseDiscrepancy: (fill) => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      height='24px'
      viewBox='0 -960 960 960'
      width='24px'
      fill={fill ? '#251163' : '#292D32'}
    >
      <path d='M120-160v-80h480v80H120Zm520-280q-83 0-141.5-58.5T440-640q0-83 58.5-141.5T640-840q83 0 141.5 58.5T840-640q0 83-58.5 141.5T640-440Zm-520-40v-80h252q7 22 16 42t22 38H120Zm0 160v-80h376q23 14 49 23.5t55 13.5v43H120Zm500-280h40v-160h-40v160Zm20 80q8 0 14-6t6-14q0-8-6-14t-14-6q-8 0-14 6t-6 14q0 8 6 14t14 6Z' />
    </svg>
  ),
  warehouseItem: (fill) => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      height='24px'
      viewBox='0 -960 960 960'
      width='24px'
      fill={fill ? '#251163' : '#292D32'}
    >
      <path d='M440-183v-274L200-596v274l240 139Zm80 0 240-139v-274L520-457v274Zm-80 92L160-252q-19-11-29.5-29T120-321v-318q0-22 10.5-40t29.5-29l280-161q19-11 40-11t40 11l280 161q19 11 29.5 29t10.5 40v318q0 22-10.5 40T800-252L520-91q-19 11-40 11t-40-11Zm200-528 77-44-237-137-78 45 238 136Zm-160 93 78-45-237-137-78 45 237 137Z' />
    </svg>
  ),
  warehouseConsolidation: (fill) => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      height='24px'
      viewBox='0 -960 960 960'
      width='24px'
      fill={fill ? '#251163' : '#292D32'}
    >
      <path d='m156-100-56-56 124-124H120v-80h240v240h-80v-104L156-100Zm648 0L680-224v104h-80v-240h240v80H736l124 124-56 56ZM120-600v-80h104L100-804l56-56 124 124v-104h80v240H120Zm480 0v-240h80v104l124-124 56 56-124 124h104v80H600ZM480-400q-33 0-56.5-23.5T400-480q0-33 23.5-56.5T480-560q33 0 56.5 23.5T560-480q0 33-23.5 56.5T480-400Z' />
    </svg>
  ),
  warehouseManifest: (fill) => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      height='24px'
      viewBox='0 -960 960 960'
      width='24px'
      fill={fill ? '#251163' : '#292D32'}
    >
      <path d='M200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h168q13-36 43.5-58t68.5-22q38 0 68.5 22t43.5 58h168q33 0 56.5 23.5T840-760v560q0 33-23.5 56.5T760-120H200Zm0-80h560v-560H200v560Zm80-80h280v-80H280v80Zm0-160h400v-80H280v80Zm0-160h400v-80H280v80Zm200-190q13 0 21.5-8.5T510-820q0-13-8.5-21.5T480-850q-13 0-21.5 8.5T450-820q0 13 8.5 21.5T480-790ZM200-200v-560 560Z' />
    </svg>
  ),
  warehouseManifestLegs: (fill) => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      height='24px'
      viewBox='0 -960 960 960'
      width='24px'
      fill={fill ? '#251163' : '#292D32'}
    >
      <path d='M200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h168q13-36 43.5-58t68.5-22q38 0 68.5 22t43.5 58h168q33 0 56.5 23.5T840-760v560q0 33-23.5 56.5T760-120H200Zm0-80h560v-560H200v560Zm80-80h280v-80H280v80Zm0-160h400v-80H280v80Zm0-160h400v-80H280v80Zm200-190q13 0 21.5-8.5T510-820q0-13-8.5-21.5T480-850q-13 0-21.5 8.5T450-820q0 13 8.5 21.5T480-790ZM200-200v-560 560Z' />
    </svg>
  ),
  warehouseManifestShipments: (fill) => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      height='24px'
      viewBox='0 -960 960 960'
      width='24px'
      fill={fill ? '#251163' : '#292D32'}
    >
      <path d='M480-120v-280q0-33 23.5-56.5T560-480h240q33 0 56.5 23.5T880-400v280h-80v-280h-80v200h-80v-200h-80v280h-80Zm-280 0q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h167q11-35 43-57.5t70-22.5q40 0 71.5 22.5T594-840h166q33 0 56.5 23.5T840-760v200h-80v-200h-80v120H280v-120h-80v560h200v80H200Zm280-640q17 0 28.5-11.5T520-800q0-17-11.5-28.5T480-840q-17 0-28.5 11.5T440-800q0 17 11.5 28.5T480-760Z' />
    </svg>
  ),
  warehouseReports: (fill) => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      height='24px'
      viewBox='0 -960 960 960'
      width='24px'
      fill={fill ? '#251163' : '#292D32'}
    >
      <path d='M200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h440l200 200v440q0 33-23.5 56.5T760-120H200Zm0-80h560v-400H600v-160H200v560Zm80-80h400v-80H280v80Zm0-320h200v-80H280v80Zm0 160h400v-80H280v80Zm-80-320v160-160 560-560Z' />
    </svg>
  ),
  warehouseLocation: (fill) => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      height='24px'
      viewBox='0 -960 960 960'
      width='24px'
      fill={fill ? '#251163' : '#292D32'}
    >
      <path d='M160-200h80v-320h480v320h80v-426L480-754 160-626v426Zm-80 80v-560l400-160 400 160v560H640v-320H320v320H80Zm280 0v-80h80v80h-80Zm80-120v-80h80v80h-80Zm80 120v-80h80v80h-80ZM240-520h480-480Z' />
    </svg>
  ),
  warehouseSubcontractor: (fill) => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      height='24px'
      viewBox='0 -960 960 960'
      width='24px'
      fill={fill ? '#251163' : '#292D32'}
    >
      <path d='M480-400q33 0 56.5-23.5T560-480q0-33-23.5-56.5T480-560q-33 0-56.5 23.5T400-480q0 33 23.5 56.5T480-400ZM320-240h320v-23q0-24-13-44t-36-30q-26-11-53.5-17t-57.5-6q-30 0-57.5 6T369-337q-23 10-36 30t-13 44v23ZM720-80H240q-33 0-56.5-23.5T160-160v-640q0-33 23.5-56.5T240-880h320l240 240v480q0 33-23.5 56.5T720-80Zm0-80v-446L526-800H240v640h480Zm-480 0v-640 640Z' />
    </svg>
  ),
  warehouseFreightType: (fill) => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      height='24px'
      viewBox='0 -960 960 960'
      width='24px'
      fill={fill ? '#251163' : '#292D32'}
    >
      <path d='m400-570 80-40 80 40v-190H400v190ZM280-280v-80h200v80H280Zm-80 160q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760v560q0 33-23.5 56.5T760-120H200Zm0-640v560-560Zm0 560h560v-560H640v320l-160-80-160 80v-320H200v560Z' />
    </svg>
  ),
  warehouseVehicleType: (fill) => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      height='24px'
      viewBox='0 -960 960 960'
      width='24px'
      fill={fill ? '#251163' : '#292D32'}
    >
      <path d='M240-160q-50 0-85-35t-35-85H40v-440q0-33 23.5-56.5T120-800h560v160h120l120 160v200h-80q0 50-35 85t-85 35q-50 0-85-35t-35-85H360q0 50-35 85t-85 35Zm0-80q17 0 28.5-11.5T280-280q0-17-11.5-28.5T240-320q-17 0-28.5 11.5T200-280q0 17 11.5 28.5T240-240ZM120-360h32q17-18 39-29t49-11q27 0 49 11t39 29h272v-360H120v360Zm600 120q17 0 28.5-11.5T760-280q0-17-11.5-28.5T720-320q-17 0-28.5 11.5T680-280q0 17 11.5 28.5T720-240Zm-40-200h170l-90-120h-80v120ZM360-540Z' />
    </svg>
  ),
  /// INSIGHTS & Performance
  dashboard: (fill?: boolean) => (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M16.19 2H7.81C4.17 2 2 4.17 2 7.81V16.18C2 19.83 4.17 22 7.81 22H16.18C19.82 22 21.99 19.83 21.99 16.19V7.81C22 4.17 19.83 2 16.19 2ZM9.91 16.19C9.91 16.83 9.39 17.35 8.74 17.35C8.1 17.35 7.58 16.83 7.58 16.19V12.93C7.58 12.29 8.1 11.77 8.74 11.77C9.39 11.77 9.91 12.29 9.91 12.93V16.19ZM16.42 16.19C16.42 16.83 15.9 17.35 15.26 17.35C14.61 17.35 14.09 16.83 14.09 16.19V7.81C14.09 7.17 14.61 6.65 15.26 6.65C15.9 6.65 16.42 7.17 16.42 7.81V16.19Z'
        fill={fill ? '#251163' : '#292D32'}
      />
    </svg>
  ),
  warehouseDasboard: (fill) => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      height='24px'
      viewBox='0 -960 960 960'
      width='24px'
      fill={fill ? '#251163' : '#292D32'}
    >
      <path d='M280-280h80v-200h-80v200Zm320 0h80v-400h-80v400Zm-160 0h80v-120h-80v120Zm0-200h80v-80h-80v80ZM200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760v560q0 33-23.5 56.5T760-120H200Zm0-80h560v-560H200v560Zm0-560v560-560Z' />
    </svg>
  ),
  warehouseManifestFreightMoved: (fill?: boolean) => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      height='24px'
      viewBox='0 -960 960 960'
      width='24px'
      fill={fill ? '#251163' : '#292D32'}
    >
      <path d='M280-280h160v-160H280v160Zm240 0h160v-160H520v160ZM280-520h160v-160H280v160Zm240 0h160v-160H520v160ZM200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760v560q0 33-23.5 56.5T760-120H200Zm0-80h560v-560H200v560Zm0-560v560-560Z' />
    </svg>
  ),
  warehouseDailyWeeklyDashboard: (fill?: boolean) => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      height='24px'
      viewBox='0 -960 960 960'
      width='24px'
      fill={fill ? '#251163' : '#292D32'}
    >
      <path d='m296-320 122-122 80 80 142-141v63h80v-200H520v80h63l-85 85-80-80-178 179 56 56Zm-96 200q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760v560q0 33-23.5 56.5T760-120H200Zm0-80h560v-560H200v560Zm0-560v560-560Z' />
    </svg>
  ),
  metricsAccountStats: (fill) => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      height='24px'
      viewBox='0 -960 960 960'
      width='24px'
      fill={fill ? '#251163' : '#292D32'}
    >
      <path d='M640-160v-280h160v280H640Zm-240 0v-640h160v640H400Zm-240 0v-440h160v440H160Z' />
    </svg>
  ),
  metricsShipmentBreakdown: (fill) => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      height='24px'
      viewBox='0 -960 960 960'
      width='24px'
      fill={fill ? '#251163' : '#292D32'}
    >
      <path d='M120-160v-240h120v240H120Zm200-240v-200h120v200H320Zm200-200v-200h120v200H520Zm200 440v-640h120v640H720Z' />
    </svg>
  ),
};

export const ScanIcon = ({ color = '#251163' }) => {
  return (
    <svg
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M2.30817 8.33366C1.94984 8.33366 1.6665 8.05032 1.6665 7.69199V5.76699C1.6665 3.50866 3.50817 1.66699 5.7665 1.66699H7.6915C8.04984 1.66699 8.33317 1.95033 8.33317 2.30866C8.33317 2.66699 8.04984 2.95033 7.6915 2.95033H5.7665C4.20817 2.95033 2.94984 4.21699 2.94984 5.76699V7.69199C2.94984 8.05032 2.65817 8.33366 2.30817 8.33366Z'
        fill={color}
      />
      <path
        d='M17.6915 8.33366C17.3415 8.33366 17.0498 8.05032 17.0498 7.69199V5.76699C17.0498 4.20866 15.7832 2.95033 14.2332 2.95033H12.3082C11.9498 2.95033 11.6665 2.65866 11.6665 2.30866C11.6665 1.95866 11.9498 1.66699 12.3082 1.66699H14.2332C16.4915 1.66699 18.3332 3.50866 18.3332 5.76699V7.69199C18.3332 8.05032 18.0498 8.33366 17.6915 8.33366Z'
        fill={color}
      />
      <path
        d='M14.2331 18.3331H13.0748C12.7248 18.3331 12.4331 18.0497 12.4331 17.6914C12.4331 17.3414 12.7164 17.0497 13.0748 17.0497H14.2331C15.7914 17.0497 17.0498 15.7831 17.0498 14.2331V13.0831C17.0498 12.7331 17.3331 12.4414 17.6914 12.4414C18.0414 12.4414 18.3331 12.7247 18.3331 13.0831V14.2331C18.3331 16.4914 16.4914 18.3331 14.2331 18.3331Z'
        fill={color}
      />
      <path
        d='M7.6915 18.3337H5.7665C3.50817 18.3337 1.6665 16.492 1.6665 14.2337V12.3087C1.6665 11.9503 1.94984 11.667 2.30817 11.667C2.6665 11.667 2.94984 11.9503 2.94984 12.3087V14.2337C2.94984 15.792 4.2165 17.0503 5.7665 17.0503H7.6915C8.0415 17.0503 8.33317 17.3337 8.33317 17.692C8.33317 18.0503 8.04984 18.3337 7.6915 18.3337Z'
        fill={color}
      />
      <path
        d='M15.3834 9.3584H14.2501H5.7501H4.61676C4.25843 9.3584 3.9751 9.65007 3.9751 10.0001C3.9751 10.3501 4.25843 10.6417 4.61676 10.6417H5.7501H14.2501H15.3834C15.7418 10.6417 16.0251 10.3501 16.0251 10.0001C16.0251 9.65007 15.7418 9.3584 15.3834 9.3584Z'
        fill={color}
      />
      <path
        d='M5.75 11.6164V11.8914C5.75 13.2747 6.86667 14.3914 8.25 14.3914H11.75C13.1333 14.3914 14.25 13.2747 14.25 11.8914V11.6164C14.25 11.5164 14.175 11.4414 14.075 11.4414H5.925C5.825 11.4414 5.75 11.5164 5.75 11.6164Z'
        fill={color}
      />
      <path
        d='M5.75 8.3834V8.1084C5.75 6.72506 6.86667 5.6084 8.25 5.6084H11.75C13.1333 5.6084 14.25 6.72506 14.25 8.1084V8.3834C14.25 8.4834 14.175 8.5584 14.075 8.5584H5.925C5.825 8.5584 5.75 8.4834 5.75 8.3834Z'
        fill={color}
      />
    </svg>
  );
};
